(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduce-motion: reduce)").matches ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------------------
     Header: adaptive veil — reads the room it's floating over
     --------------------------------------------------------------------- */
  var header = document.querySelector("[data-site-header]");
  if (header) {
    /* Rooms with a dark floor. The header reads whichever one is passing
       beneath it and dresses itself to match, so it never flashes cream
       across a vinyl-black room. Add data-header-tone="dark" to any future
       section to enrol it. */
    var TONE_ZONES = [
      { sel: ".hero, .act--dark, .player-section, .hallway, .vestibule, .archive--dark, .footer, [data-header-tone='dark']", from: 0, to: 1 },
      /* the Act III bridge melts from vinyl into cream — dark only up top */
      { sel: ".act--light", from: 0, to: 0.58 }
    ];
    /* full-bleed openings that deserve a bare header before the first scroll */
    var OPEN_TOP = ".hero, .vestibule, .shopfront, [data-header-open-top]";

    var bands = [];
    var openTop = false;
    var baseTone = "light";
    var probeMax = Infinity;
    var tone = null;
    var lift = null;
    var veiled = null;
    var queued = false;

    document.documentElement.classList.add("hdr-live");

    function measureTone() {
      var sy = window.pageYOffset || 0;
      var raw = [];
      for (var z = 0; z < TONE_ZONES.length; z++) {
        var nodes = document.querySelectorAll(TONE_ZONES[z].sel);
        for (var i = 0; i < nodes.length; i++) {
          var r = nodes[i].getBoundingClientRect();
          if (r.height < 8) continue;
          raw.push([
            r.top + sy + r.height * TONE_ZONES[z].from,
            r.top + sy + r.height * TONE_ZONES[z].to
          ]);
        }
      }
      /* Coalesce. The homepage runs hero → act → player → act → hallway as one
         unbroken dark stretch; without this each seam between them would read
         as a boundary and the mark would flicker its way down the page. Only
         the real edges — where dark actually meets light — should survive. */
      raw.sort(function (p, q) { return p[0] - q[0]; });
      var merged = [];
      for (var k = 0; k < raw.length; k++) {
        var n = merged.length;
        if (n && raw[k][0] <= merged[n - 1] + 2) {
          if (raw[k][1] > merged[n - 1]) merged[n - 1] = raw[k][1];
        } else {
          merged.push(raw[k][0], raw[k][1]);
        }
      }

      /* the furthest the probe can ever reach */
      var docH = Math.max(
        document.documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      probeMax = Math.max(0, docH - window.innerHeight) + (header.offsetHeight || 64) * 0.55;

      /* Discard any room the header can only ever graze. The footer is the
         one that matters: if the page runs out of scroll a moment after you
         enter it, the crossing can't finish, and the stave would retract part
         way and park there. Better never to start than to stop half-drawn. */
      bands.length = 0;
      for (var m = 0; m < merged.length; m += 2) {
        if (merged[m] > probeMax - 90) continue;
        bands.push(merged[m], merged[m + 1]);
      }

      /* the art gallery is one unbroken dark room, gaps included */
      baseTone = document.body.classList.contains("suffix-art-gallery") ? "dark" : "light";

      var main = document.getElementById("MainContent");
      var first = main ? main.querySelector(OPEN_TOP) : null;
      openTop = !!(first && first.getBoundingClientRect().top + sy < 140);
    }

    /* how long the crossing takes, in pixels of scroll. The mark's shadow is
       drawn in over this runway rather than transitioned over a duration, so
       it tracks the finger — a fast flick still reads as a change in the page
       rather than something popping into existence. */
    var RUNWAY = 220;

    function paintTone() {
      queued = false;
      var sy = window.pageYOffset || 0;
      /* probe the page at the header's own waistline */
      var probe = sy + (header.offsetHeight || 64) * 0.55;

      var inDark = false;
      var dist = Infinity;
      var edge = null;
      for (var i = 0; i < bands.length; i += 2) {
        var a = bands[i], b = bands[i + 1];
        if (probe >= a && probe < b) {
          inDark = true;
          /* the top of the document isn't a boundary — there's nothing above
             it to cross into, so don't ramp against it */
          var dTop = a <= 1 ? Infinity : probe - a;
          var dBot = b - probe;
          if (dTop < dBot) { dist = dTop; edge = a; } else { dist = dBot; edge = b; }
          break;
        }
        var da = Math.abs(probe - a), db = Math.abs(probe - b);
        if (da < dist) { dist = da; edge = a; }
        if (db < dist) { dist = db; edge = b; }
      }
      /* the art gallery is dark even in the gaps between its rooms */
      if (baseTone === "dark" && !inDark) { inDark = true; dist = RUNWAY; edge = null; }

      /* Compress the runway when the page is about to run out of scroll. The
         footer is the case that matters: on a short viewport you cross into it
         and hit the bottom of the document a moment later, so a fixed runway
         would freeze the stave half-retracted and leave it parked there. Here
         the ramp is squeezed to whatever travel actually remains, so it always
         lands on a whole number — fully in, or fully out. */
      var half = RUNWAY / 2;
      if (edge !== null) {
        /* squeeze from BOTH sides — the ramp is centred on the edge, so if the
           page ends before edge + half, it has to be narrowed while the probe
           is still approaching, not only once it's past */
        half = Math.max(40, Math.min(half, probeMax - edge));
      }

      var t = Math.min(1, dist / half);
      var v = inDark ? (1 - t) / 2 : (1 + t) / 2;
      v = v * v * (3 - 2 * v);   /* smoothstep — no kink at either end */

      if (lift === null || Math.abs(v - lift) > 0.008) {
        lift = v;
        header.style.setProperty("--lift", v.toFixed(3));
      }

      var room = v < 0.5 ? "dark" : "light";
      if (room !== tone) { tone = room; header.setAttribute("data-tone", room); }

      var vl = sy > 40 || !openTop;
      if (vl !== veiled) { veiled = vl; header.classList.toggle("is-solid", vl); }
    }

    function queueTone() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(paintTone);
    }

    /* Publish the mark's real rendered height so CSS can work out how tall the
       header actually is. The logo is a wide artwork inside a square-named PNG,
       so its height is nothing you can derive from the width setting — it has to
       be measured. Everything that needs to clear the fixed header reads
       --header-clear, which is built from this. */
    function publishMarkHeight() {
      var img = header.querySelector(".site-header__logo-img");
      var h = img ? img.offsetHeight : 0;
      if (h > 0) document.documentElement.style.setProperty("--mark-real-h", h + "px");
    }

    function syncTone() { measureTone(); publishMarkHeight(); paintTone(); }
    window.__bsHeaderTone = function () {
      syncTone();
      /* layout settles a beat after a swap on iOS */
      setTimeout(syncTone, 160);
    };

    syncTone();
    var markImg = header.querySelector(".site-header__logo-img");
    if (markImg && !markImg.complete) markImg.addEventListener("load", syncTone, { once: true });
    window.addEventListener("scroll", queueTone, { passive: true });
    window.addEventListener("resize", syncTone);
    window.addEventListener("load", syncTone);
    window.addEventListener("orientationchange", function () { setTimeout(syncTone, 200); });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { measureTone(); queueTone(); });
      ro.observe(document.body);
      var mainEl = document.getElementById("MainContent");
      if (mainEl) ro.observe(mainEl);
    }
  }

  /* ---------------------------------------------------------------------
     Mobile nav toggle
     --------------------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var burger = e.target.closest && e.target.closest("[data-menu-toggle]");
    var mobileNav = document.querySelector("[data-mobile-nav]");
    if (!mobileNav) return;
    if (burger) {
      var open = mobileNav.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
      document.body.classList.toggle("menu-open", open);
      if (open && window.__bsFillMenuArt) window.__bsFillMenuArt();
      return;
    }
    if (e.target.closest && e.target.closest("[data-mobile-nav] a")) {
      mobileNav.classList.remove("is-open");
      document.body.style.overflow = "";
      document.body.classList.remove("menu-open");
    }
  });

  /* ---------------------------------------------------------------------
     Generic scroll reveal
     --------------------------------------------------------------------- */
  var revealEls = document.querySelectorAll(".reveal");
  if (prefersReducedMotion || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
    window.__bsReveal = function (root) {
      (root || document).querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-visible"); });
    };
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
    window.__bsReveal = function (root) {
      (root || document).querySelectorAll(".reveal").forEach(function (el) {
        if (!el.classList.contains("is-visible")) io.observe(el);
      });
    };
  }

  /* ---------------------------------------------------------------------
     Gallery hallway — focus the piece nearest center of viewport
     --------------------------------------------------------------------- */
  var touchDevice = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  if (document.querySelector("[data-hallway-piece]") && !touchDevice) {
    var focusNearest = function () {
      var center = window.innerHeight / 2;
      document.querySelectorAll("[data-hallway-piece]").forEach(function (piece) {
        var rect = piece.getBoundingClientRect();
        var pieceCenter = rect.top + rect.height / 2;
        var distance = Math.abs(center - pieceCenter);
        var proximity = Math.max(0, 1 - distance / (window.innerHeight * 0.7));
        if (prefersReducedMotion) {
          piece.classList.add("is-focused");
          return;
        }
        if (proximity > 0.35) {
          piece.classList.add("is-focused");
        } else {
          piece.classList.remove("is-focused");
        }
      });
    };
    focusNearest();
    window.__bsFocusHallway = focusNearest;
    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            focusNearest();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener("resize", focusNearest);
  }

  /* ---------------------------------------------------------------------
     Custom audio player (works per player instance on the page)
     --------------------------------------------------------------------- */
  /* -------------------------------------------------------------------
     SoundCloud engine: a hidden official SoundCloud widget powers playback
     for pasted SoundCloud links, while the tape-deck UI stays in control.
     ------------------------------------------------------------------- */
  var scEngine = {
    widget: null, booting: false, cbs: [], loadedUrl: null, bound: false, durSec: 0
  };
  window.__bsMode = window.__bsMode || "file";
  window.__bsNowPlaying = window.__bsNowPlaying || false;

  function bsAnnounce(playing, mode) {
    window.__bsNowPlaying = playing;
    if (mode) window.__bsMode = mode;
    document.dispatchEvent(new CustomEvent("bs:state", { detail: { playing: playing } }));
  }

  function isSoundCloudSrc(src) {
    return src && src.indexOf("soundcloud.com") !== -1 && src.indexOf(".mp3") === -1;
  }

  function scEnsure(trackUrl, cb) {
    if (scEngine.widget) { cb(scEngine.widget); return; }
    scEngine.cbs.push(cb);
    if (scEngine.booting) return;
    scEngine.booting = true;
    var iframe = document.createElement("iframe");
    iframe.setAttribute("data-sc-iframe", "");
    iframe.allow = "autoplay";
    iframe.title = "SoundCloud player";
    iframe.style.cssText = "position:fixed;left:-9999px;bottom:0;width:4px;height:4px;opacity:0.01;pointer-events:none;border:0;";
    iframe.src = "https://w.soundcloud.com/player/?url=" + encodeURIComponent(trackUrl) + "&auto_play=false&show_teaser=false&visual=false";
    document.body.appendChild(iframe);
    scEngine.loadedUrl = trackUrl;
    var boot = function () {
      var w = window.SC.Widget(iframe);
      w.bind(window.SC.Widget.Events.READY, function () {
        scEngine.widget = w;
        scBindGlobal(w);
        w.setVolume(100);
        w.getDuration(function (ms) { scEngine.durSec = ms / 1000; document.dispatchEvent(new CustomEvent("bs:sc-duration")); });
        scEngine.cbs.forEach(function (f) { f(w); });
        scEngine.cbs = [];
      });
    };
    if (window.SC && window.SC.Widget) { boot(); }
    else {
      var s = document.createElement("script");
      s.src = "https://w.soundcloud.com/player/api.js";
      s.onload = boot;
      document.head.appendChild(s);
    }
  }

  function scBindGlobal(w) {
    if (scEngine.bound) return;
    scEngine.bound = true;
    var Ev = window.SC.Widget.Events;
    w.bind(Ev.PLAY, function () {
      if (scEngine.priming && !scEngine.userWants) {
        /* silent prime succeeded: stream is loaded + iOS-blessed. Rewind quietly. */
        scEngine.suppressPause = true;
        w.pause();
        w.seekTo(0);
        w.setVolume(100);
        scEngine.priming = false;
        scEngine.primed = true;
        return;
      }
      if (scEngine.priming && scEngine.userWants) {
        /* user pressed play mid-prime: let it ride, just restore the volume */
        w.setVolume(100);
        scEngine.priming = false;
        scEngine.primed = true;
      }
      scEngine.userWants = false;
      bsAnnounce(true, "sc");
    });
    w.bind(Ev.PAUSE, function () {
      if (scEngine.suppressPause) { scEngine.suppressPause = false; return; }
      bsAnnounce(false, "sc");
    });
    w.bind(Ev.FINISH, function () { bsAnnounce(false, "sc"); document.dispatchEvent(new CustomEvent("bs:sc-finish")); });
    w.bind(Ev.PLAY_PROGRESS, function (e) {
      document.dispatchEvent(new CustomEvent("bs:sc-progress", { detail: e }));
    });
    if (Ev.ERROR) {
      w.bind(Ev.ERROR, function () {
        bsAnnounce(false, "sc");
        document.dispatchEvent(new CustomEvent("bs:sc-error"));
      });
    }
  }

  function scLoad(trackUrl, thenPlay) {
    scEnsure(trackUrl, function (w) {
      if (scEngine.loadedUrl === trackUrl) {
        if (thenPlay) w.play();
        return;
      }
      scEngine.loadedUrl = trackUrl;
      scEngine.primed = false;
      scEngine.priming = false;
      w.load("https://w.soundcloud.com/player/?url=" + encodeURIComponent(trackUrl) + "&show_teaser=false&visual=false", {
        auto_play: !!thenPlay,
        callback: function () {
          w.getDuration(function (ms) { scEngine.durSec = ms / 1000; document.dispatchEvent(new CustomEvent("bs:sc-duration")); });
        }
      });
    });
  }
  function scPrime() {
    if (scEngine.primed || scEngine.priming || !scEngine.widget || window.__bsNowPlaying) return;
    scEngine.priming = true;
    scEngine.widget.setVolume(0);
    scEngine.widget.play();
  }
  document.addEventListener("pointerdown", function primeOnce() {
    scPrime();
    /* if the widget wasn't ready yet, later gestures can still prime */
    if (scEngine.primed || scEngine.priming) {
      document.removeEventListener("pointerdown", primeOnce, true);
    }
  }, true);

  window.__bsScLoad = scLoad;
  window.__bsScEngine = scEngine;
  window.__bsScEnsure = scEnsure;

  function initPlayer(playerEl) {
    if (playerEl.dataset.bsInit) return;
    playerEl.dataset.bsInit = "1";
    var audio = document.querySelector("[data-global-audio]") || playerEl.querySelector("audio");
    var playBtn = playerEl.querySelector("[data-player-play]");
    var prevBtn = playerEl.querySelector("[data-player-prev]");
    var nextBtn = playerEl.querySelector("[data-player-next]");
    var progressBar = playerEl.querySelector("[data-player-progress-bar]");
    var progressWrap = playerEl.querySelector("[data-player-progress]");
    var currentTimeEl = playerEl.querySelector("[data-player-current]");
    var durationEl = playerEl.querySelector("[data-player-duration]");
    var titleEl = playerEl.querySelector("[data-player-title]");
    var artistEl = playerEl.querySelector("[data-player-artist]");
    var disc = playerEl.querySelector("[data-player-disc]");
    var tracks = playerEl.querySelectorAll("[data-player-track]");
    var embedToggle = playerEl.querySelector("[data-player-embed-toggle]");
    var embedWrap = playerEl.querySelector("[data-player-embed-wrap]");

    if (!audio) return;

    var activeIndex = 0;

    function formatTime(sec) {
      if (!isFinite(sec)) return "0:00";
      var m = Math.floor(sec / 60);
      var s = Math.floor(sec % 60);
      return m + ":" + (s < 10 ? "0" : "") + s;
    }

    var scActive = false;

    function loadTrack(index, thenPlay) {
      var track = tracks[index];
      if (!track) return;
      activeIndex = index;
      var src = track.getAttribute("data-src") || "";
      scActive = isSoundCloudSrc(src);
      audio.dataset.title = track.getAttribute("data-title") || "";
      audio.dataset.artist = track.getAttribute("data-artist") || "";
      if (titleEl) titleEl.textContent = track.getAttribute("data-title") || "";
      if (artistEl) artistEl.textContent = track.getAttribute("data-artist") || "";
      tracks.forEach(function (t, i) { t.classList.toggle("is-active", i === index); });
      if (progressBar) progressBar.style.width = "0%";
      if (currentTimeEl) currentTimeEl.textContent = "0:00";
      if (scActive) {
        try { audio.pause(); } catch (err) {}
        audio.removeAttribute("src");
        audio.dataset.scurl = src;
        window.__bsScUrl = src;
        window.__bsMode = "sc";
        if (thenPlay) awaitSC();
        scLoad(src, !!thenPlay);
      } else {
        window.__bsMode = "file";
        audio.src = src;
        if (thenPlay) play();
      }
    }

    function setPlayingUI(playing) {
      if (playBtn) {
        playBtn.setAttribute("aria-label", playing ? "Pause" : "Play");
        playBtn.innerHTML = playing ? ICON_PAUSE : ICON_PLAY;
      }
      if (disc) disc.classList.toggle("is-playing", playing);
    }

    var scWatch = null;
    var scRetry = null;
    function awaitSC() {
      hideNotice();
      if (playBtn) playBtn.classList.add("is-waiting");
      clearTimeout(scWatch);
      clearTimeout(scRetry);
      /* automatic "second tap": if the stream loaded but the first play was
         swallowed (classic iOS), a retry ~1s in starts it without user effort */
      scRetry = setTimeout(function () {
        if (!window.__bsNowPlaying && scEngine.widget) {
          scEngine.userWants = true;
          scEngine.widget.play();
        }
      }, 1100);
      scWatch = setTimeout(function () {
        if (!window.__bsNowPlaying) {
          if (playBtn) playBtn.classList.remove("is-waiting");
          setPlayingUI(false);
          showNotice("SoundCloud couldn't start this track \u2014 the owner may restrict external playback. Try one of your own tracks, or an MP3 upload.");
        }
      }, 3600);
    }
    function showNotice(msg) {
      var n = playerEl.querySelector("[data-player-notice]");
      if (!n) {
        n = document.createElement("p");
        n.setAttribute("data-player-notice", "");
        n.className = "player__notice";
        var timeRow = playerEl.querySelector(".player__time");
        if (timeRow && timeRow.parentNode) timeRow.parentNode.insertBefore(n, timeRow.nextSibling);
        else playerEl.appendChild(n);
      }
      n.textContent = msg;
      n.classList.add("is-visible");
    }
    function hideNotice() {
      var n = playerEl.querySelector("[data-player-notice]");
      if (n) n.classList.remove("is-visible");
    }

    function play() {
      if (scActive) {
        scEngine.userWants = true;
        awaitSC();
        if (scEngine.priming) {
          /* this very tap already sent a (muted) play via priming — the PLAY
             handler will unmute and announce it. A second command here would
             make SoundCloud stumble. One gesture, one command. */
          return;
        }
        scEnsure(audio.dataset.scurl, function (w) { w.play(); });
        return;
      }
      audio.play().then(function () {
        setPlayingUI(true);
        bsAnnounce(true, "file");
      }).catch(function () { setPlayingUI(false); });
    }

    function pause() {
      if (scActive) {
        if (scEngine.widget) scEngine.widget.pause();
        setPlayingUI(false);
        return;
      }
      audio.pause();
      setPlayingUI(false);
      bsAnnounce(false, "file");
    }

    function isPlayingNow() {
      return scActive ? window.__bsNowPlaying : !audio.paused;
    }

    var ICON_PLAY = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
    var ICON_PAUSE = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';

    if (tracks.length) {
      var playingTitle = audio.dataset.title;
      var matched = -1;
      if (playingTitle) {
        tracks.forEach(function (t, i) { if (t.getAttribute("data-title") === playingTitle) matched = i; });
      }
      if (matched >= 0) {
        /* a track is already loaded (possibly playing) — sync UI, don't restart */
        activeIndex = matched;
        tracks.forEach(function (t, i) { t.classList.toggle("is-active", i === matched); });
        if (titleEl) titleEl.textContent = playingTitle;
        if (artistEl) artistEl.textContent = audio.dataset.artist || "Butter Smooth";
        scActive = window.__bsMode === "sc";
        if (scActive) audio.dataset.scurl = window.__bsScUrl || audio.dataset.scurl;
        if (window.__bsNowPlaying || !audio.paused) setPlayingUI(true);
      } else if (window.__bsNowPlaying) {
        /* a different track is playing (e.g. SoundCloud) — leave it alone */
      } else if (!audio.src || audio.paused) {
        loadTrack(0);
      }
    }

    if (playBtn) {
      playBtn.addEventListener("click", function () {
        if (isPlayingNow()) pause(); else play();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        loadTrack((activeIndex + 1) % tracks.length, true);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        loadTrack((activeIndex - 1 + tracks.length) % tracks.length, true);
      });
    }
    tracks.forEach(function (track, i) {
      track.addEventListener("click", function () {
        loadTrack(i, true);
      });
    });

    audio.addEventListener("timeupdate", function () {
      if (!audio.duration) return;
      var pct = (audio.currentTime / audio.duration) * 100;
      if (progressBar) progressBar.style.width = pct + "%";
      if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
    });
    audio.addEventListener("loadedmetadata", function () {
      if (durationEl) durationEl.textContent = formatTime(audio.duration);
    });
    audio.addEventListener("ended", function () {
      if (scActive) return;
      if (tracks.length > 1) {
        loadTrack((activeIndex + 1) % tracks.length, true);
      } else {
        pause();
      }
    });

    /* SoundCloud engine events drive this deck when an SC track is active */
    document.addEventListener("bs:sc-progress", function (ev) {
      if (!scActive) return;
      var pos = (ev.detail && ev.detail.currentPosition ? ev.detail.currentPosition : 0) / 1000;
      if (scEngine.durSec && progressBar) progressBar.style.width = ((pos / scEngine.durSec) * 100) + "%";
      if (currentTimeEl) currentTimeEl.textContent = formatTime(pos);
    });
    document.addEventListener("bs:sc-duration", function () {
      if (!scActive) return;
      if (durationEl) durationEl.textContent = formatTime(scEngine.durSec);
    });
    document.addEventListener("bs:sc-finish", function () {
      if (!scActive) return;
      if (tracks.length > 1) loadTrack((activeIndex + 1) % tracks.length, true);
      else setPlayingUI(false);
    });
    document.addEventListener("bs:state", function (e) {
      if (!scActive) return;
      var playing = !!(e.detail && e.detail.playing);
      if (playing) {
        clearTimeout(scWatch);
        clearTimeout(scRetry);
        if (playBtn) playBtn.classList.remove("is-waiting");
        hideNotice();
      }
      setPlayingUI(playing);
    });
    document.addEventListener("bs:sc-error", function () {
      if (!scActive) return;
      clearTimeout(scWatch);
      if (playBtn) playBtn.classList.remove("is-waiting");
      setPlayingUI(false);
      showNotice("SoundCloud reported a playback error for this track. It may be restricted for embedding \u2014 try another track or an MP3 upload.");
    });

    if (progressWrap) {
      progressWrap.addEventListener("click", function (e) {
        var rect = progressWrap.getBoundingClientRect();
        var pct = (e.clientX - rect.left) / rect.width;
        if (scActive) {
          if (scEngine.widget && scEngine.durSec) scEngine.widget.seekTo(pct * scEngine.durSec * 1000);
        } else if (audio.duration) {
          audio.currentTime = pct * audio.duration;
        }
      });
    }
    if (embedToggle && embedWrap) {
      embedToggle.addEventListener("click", function () {
        var open = embedWrap.classList.toggle("is-open");
        embedToggle.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) pause();
      });
    }
  }
  document.querySelectorAll("[data-player]").forEach(initPlayer);
  window.__bsInitPlayer = initPlayer;

  /* ---------------------------------------------------------------------
     Product page: thumbnail swap + quantity stepper + AJAX add to cart
     --------------------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-product-thumbs] img");
    if (!thumb) return;
    var main = document.querySelector("[data-product-main-image]");
    if (main) main.src = thumb.getAttribute("data-full") || thumb.src;
    var artStage = document.querySelector("[data-product-canvas]");
    if (artStage) {
      artStage.setAttribute("data-src", thumb.getAttribute("data-full") || thumb.src);
      artStage.dataset.built = "";
      if (window.__bsProductCanvas) window.__bsProductCanvas(document);
    }
    thumb.closest("[data-product-thumbs]").querySelectorAll("img").forEach(function (t) {
      t.classList.remove("is-active");
    });
    thumb.classList.add("is-active");
  });

  document.addEventListener("click", function (e) {
    var minus = e.target.closest("[data-qty-minus]");
    var plus = e.target.closest("[data-qty-plus]");
    if (!minus && !plus) return;
    var btn = minus || plus;
    var input = btn.parentElement.querySelector("input");
    if (!input) return;
    if (minus) input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
    else input.value = parseInt(input.value || "1", 10) + 1;
    if (window.__bsCursor) window.__bsCursor("view", String(input.value));
  });

  function refreshCartBadges() {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart.js", {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        /* header badge */
        var cartLink = document.querySelector(".site-header__actions a[href*='cart']");
        if (cartLink) {
          var badge = cartLink.querySelector(".site-header__cart-count");
          if (n > 0) {
            if (!badge) {
              badge = document.createElement("span");
              badge.className = "site-header__cart-count";
              cartLink.appendChild(badge);
            }
            badge.textContent = n;
          } else if (badge) {
            badge.remove();
          }
          cartLink.setAttribute("aria-label", "Cart (" + n + " items)");
        }
        /* nav pill */
        document.querySelectorAll("[data-nav-pill] a[href*='cart']").forEach(function (a) {
          a.textContent = n > 0 ? "Cart (" + n + ")" : "Cart";
        });
      })
      .catch(function () {});
  }
  window.__bsCartBadges = refreshCartBadges;

  document.addEventListener("submit", function (e) {
    var addForm = e.target.closest("[data-product-form]");
    if (!addForm) return;
    {
      e.preventDefault();
      var submitBtn = addForm.querySelector("[type='submit']");
      var originalText = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) { submitBtn.textContent = "Adding\u2026"; submitBtn.disabled = true; }

      /* belt & suspenders: re-derive the variant from the checked swatches
         right now, so the sent size always matches what's on screen */
      if (window.__bsPrimeVariants) window.__bsPrimeVariants(addForm.parentElement || document);
      var payload = Object.fromEntries(new FormData(addForm));
      var idInput = addForm.querySelector("[data-variant-id]");
      if (idInput && idInput.value) payload.id = idInput.value;

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (submitBtn) { submitBtn.textContent = "Added"; }
          refreshCartBadges();
          setTimeout(function () {
            if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
          }, 1600);
        })
        .catch(function () {
          if (submitBtn) { submitBtn.textContent = "Try again"; submitBtn.disabled = false; }
        });
    }
  });

  /* ---------------------------------------------------------------------
     Newsletter form — visual confirmation only if not connected to Shopify's
     native customer form (footer.liquid uses the real /contact#footer route)
     --------------------------------------------------------------------- */
})();

/* ==========================================================================
   V2 — IMMERSIVE LAYER
   ========================================================================== */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  /* ---------------------------------------------------------------------
     CUSTOM CURSOR — dot + trailing ring, contextual morphs
     --------------------------------------------------------------------- */
  if (finePointer && !reduceMotion) {
    document.body.classList.add("has-custom-cursor");
    var dot = document.createElement("div");
    dot.className = "cursor";
    var ring = document.createElement("div");
    ring.className = "cursor__ring";
    var label = document.createElement("div");
    label.className = "cursor__label";
    document.body.appendChild(ring);
    document.body.appendChild(dot);
    document.body.appendChild(label);

    var mouse = { x: -100, y: -100 };
    var ringPos = { x: -100, y: -100 };

    document.addEventListener("mousemove", function (e) {
      mouse.x = e.clientX; mouse.y = e.clientY;
      dot.style.transform = "translate(" + (mouse.x - dot.offsetWidth / 2) + "px," + (mouse.y - dot.offsetHeight / 2) + "px)";
      label.style.transform = "translate(" + (mouse.x - label.offsetWidth / 2) + "px," + (mouse.y - label.offsetHeight / 2) + "px)";
    });
    document.addEventListener("mouseleave", function () { document.body.classList.add("cursor--hidden"); });
    document.addEventListener("mouseenter", function () { document.body.classList.remove("cursor--hidden"); });

    (function ringLoop() {
      ringPos.x = lerp(ringPos.x, mouse.x, 0.12);
      ringPos.y = lerp(ringPos.y, mouse.y, 0.12);
      ring.style.transform = "translate3d(" + (ringPos.x - ring.offsetWidth / 2).toFixed(2) + "px," + (ringPos.y - ring.offsetHeight / 2).toFixed(2) + "px,0)";
      requestAnimationFrame(ringLoop);
    })();

    var setMode = function (mode, text) {
      document.body.classList.remove("cursor--view", "cursor--play", "cursor--walk", "cursor--link");
      if (mode) document.body.classList.add("cursor--" + mode);
      label.textContent = text || "";
      /* pill grows to fit the word — never cramped, never clipped */
      var w = Math.max(64, (text || "").length * 7.4 + 30);
      document.documentElement.style.setProperty("--coin-w", w + "px");
    };

    /* Resolve a short label for any interactive element:
       data-cursor attr > aria-label > visible text — trimmed to fit the pill */
    var labelFor = function (el) {
      var raw = el.getAttribute("data-cursor") || el.getAttribute("aria-label") || el.textContent || "";
      raw = raw.replace(/\s+/g, " ").trim();
      raw = raw.replace(/\s*[\u2014\u2013(].*$/, "").trim(); /* drop "— $20" / "(3 items)" tails */
      if (raw.length > 18) {
        var words = raw.split(" ");
        raw = words.slice(0, 2).join(" ");
        if (raw.length > 18) raw = words[0].slice(0, 14);
      }
      return raw;
    };

    document.addEventListener("mouseover", function (e) {
      var t = e.target;
      /* special moments keep their bespoke verbs */
      if (t.closest("[data-lightbox-open]")) return setMode("view", "View");
      if (t.closest("[data-player-play], [data-player-track]")) return setMode("play", "Play");
      if (t.closest(".hallway__door-frame")) return setMode("walk", "Enter");
      /* quantity steppers show the live count, not their labels */
      var qbtn = t.closest("[data-qty-minus], [data-qty-plus]");
      if (qbtn) {
        var qinput = qbtn.parentElement.querySelector("input");
        return setMode("view", qinput ? String(qinput.value) : "");
      }
      var cbtn = t.closest("[data-crate-minus], [data-crate-plus]");
      if (cbtn) {
        var crow = cbtn.closest("[data-crate-line]");
        var cq = crow && crow.querySelector("[data-crate-qty]");
        return setMode("view", cq ? cq.textContent.trim() : "");
      }
      /* every other button, link, icon and form control gets the coin + word */
      var el = t.closest("a, button, [role='button'], input[type='submit'], summary");
      if (el) {
        var word = labelFor(el);
        if (word) return setMode("view", word);
        return setMode("link", "");
      }
      setMode(null, "");
    });

    /* let other modules (quantity stepper, cart) update the pill in real time */
    window.__bsCursor = setMode;
  }

  /* ---------------------------------------------------------------------
     THE VOYAGER — spinning record with a melting butter label that
     travels the page in a lazy figure-8, weaving behind & in front.
     --------------------------------------------------------------------- */
  /* No width gate. This used to read `window.innerWidth > 380`, which meant the
     voyager simply never existed on a 375pt phone — an iPhone SE, an 8, a 13
     mini, or anything running Display Zoom. Same markup, same settings, and the
     record was missing on every page for half of all phones. It is sized in vw
     now, so it scales instead of needing to be withheld. */
  if (!reduceMotion) {
    var voyager = document.createElement("div");
    voyager.className = "voyager";
    voyager.setAttribute("aria-hidden", "true");
    var logoUrl = document.body.getAttribute("data-voyager-logo") || "";
    var labelMarkup = logoUrl
      ? '<clipPath id="labelClip"><circle cx="50" cy="50" r="17"/></clipPath>' : "";
    voyager.innerHTML =
      '<svg class="voyager__disc" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
      '<defs><radialGradient id="vinylSheen" cx="35%" cy="30%" r="80%">' +
      '<stop offset="0%" stop-color="#2e2820"/><stop offset="55%" stop-color="#16130F"/><stop offset="100%" stop-color="#0c0a08"/></radialGradient>' +
      labelMarkup +
      '</defs>' +
      '<circle cx="50" cy="50" r="49" fill="url(#vinylSheen)" stroke="#9C7A3C" stroke-width="0.6" stroke-opacity="0.5"/>' +
      '<g fill="none" stroke="#F2E9D8" stroke-opacity="0.07">' +
      '<circle cx="50" cy="50" r="44"/><circle cx="50" cy="50" r="40"/><circle cx="50" cy="50" r="36"/><circle cx="50" cy="50" r="32"/><circle cx="50" cy="50" r="28"/><circle cx="50" cy="50" r="24"/>' +
      '</g>' +
      (logoUrl
        ? '<image href="' + logoUrl + '" xlink:href="' + logoUrl + '" x="33" y="33" width="34" height="34" clip-path="url(#labelClip)" preserveAspectRatio="xMidYMid slice"/>' +
          '<circle cx="50" cy="50" r="17" fill="none" stroke="#9C7A3C" stroke-width="0.8" stroke-opacity="0.8"/>'
        : '<circle cx="50" cy="50" r="17" fill="#C98A3B"/>') +
      '<circle cx="50" cy="50" r="1.8" fill="#16130F" stroke="#F2E9D8" stroke-width="0.4" stroke-opacity="0.5"/>' +
      '</svg>';
    document.body.appendChild(voyager);

    var vSize = function () { return voyager.offsetWidth || 140; };
    var vPos = { x: window.innerWidth * 0.8, y: window.innerHeight * 0.3, r: 0 };
    var vTarget = { x: vPos.x, y: vPos.y };
    var lastNote = 0;
    var notes = ["\u266A", "\u266B", "\u2669", "\u266C"];

    /* Waypoints as fractions of document scroll: one lazy figure-8.
       The record lives permanently in the background layer — it glides
       over the hero & act-divider backdrops and slides smoothly under
       the player, gallery and merch sections (never on top of content). */
    var path = [
      { p: 0.00, x: 0.80, y: 0.32 },
      { p: 0.12, x: 0.55, y: 0.55 },
      { p: 0.24, x: 0.15, y: 0.70 },
      { p: 0.36, x: 0.08, y: 0.42 },
      { p: 0.48, x: 0.50, y: 0.28 },
      { p: 0.60, x: 0.88, y: 0.48 },
      { p: 0.72, x: 0.80, y: 0.74 },
      { p: 0.84, x: 0.30, y: 0.62 },
      { p: 0.94, x: 0.14, y: 0.36 },
      { p: 1.00, x: 0.50, y: 0.55 }
    ];

    function sampleCatmull(t) {
      /* find segment */
      var i = 0;
      while (i < path.length - 2 && t > path[i + 1].p) i++;
      var p0 = path[Math.max(0, i - 1)], p1 = path[i], p2 = path[i + 1], p3 = path[Math.min(path.length - 1, i + 2)];
      var seg = (t - p1.p) / Math.max(0.0001, (p2.p - p1.p));
      seg = Math.min(1, Math.max(0, seg));
      var s2 = seg * seg, s3 = s2 * seg;
      var cm = function (a, b, c, d) {
        return 0.5 * ((2 * b) + (-a + c) * seg + (2 * a - 5 * b + 4 * c - d) * s2 + (-a + 3 * b - 3 * c + d) * s3);
      };
      return {
        x: cm(p0.x, p1.x, p2.x, p3.x),
        y: cm(p0.y, p1.y, p2.y, p3.y)
      };
    }

    var awake = false;
    var smoothT = 0; /* scroll progress is itself eased — fast scrolls become slow glides */
    function voyagerFrame() {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var s;
      var freeRoam = !document.body.classList.contains("template-index") &&
                     !document.body.classList.contains("suffix-art-gallery");
      if (freeRoam || docH < window.innerHeight * 1.6) {
        /* Short pages (contact, cart, login): scroll would compress the whole
           flight into a few hundred pixels and feel twitchy. Instead the
           record drifts on its own — a slow, autonomous figure-8 in time. */
        var tt = performance.now() / 26000;
        s = {
          x: 0.5 + 0.36 * Math.sin(tt * Math.PI * 2),
          y: 0.45 + 0.26 * Math.sin(tt * Math.PI * 4)
        };
      } else {
        var rawT = docH > 0 ? Math.min(1, Math.max(0, window.scrollY / docH)) : 0;
        smoothT = lerp(smoothT, rawT, 0.045);
        s = sampleCatmull(smoothT);
      }

      /* gentle bob so it feels alive even when scroll is still */
      var bob = Math.sin(performance.now() / 1600) * 7;

      vTarget.x = s.x * (window.innerWidth - vSize());
      vTarget.y = s.y * (window.innerHeight - vSize()) + bob;

      var dx = vTarget.x - vPos.x;
      vPos.x = lerp(vPos.x, vTarget.x, 0.07);
      vPos.y = lerp(vPos.y, vTarget.y, 0.07);
      /* bank into turns like it's swimming */
      var bank = Math.max(-12, Math.min(12, dx * 0.04));
      vPos.r = lerp(vPos.r, bank, 0.06);

      voyager.style.transform = "translate3d(" + vPos.x.toFixed(2) + "px," + vPos.y.toFixed(2) + "px,0) rotate(" + vPos.r.toFixed(2) + "deg)";
      if (!awake) { voyager.classList.add("is-awake"); awake = true; }

      /* drop a drifting note occasionally while moving */
      var speed = Math.abs(dx);
      var now = performance.now();
      if (speed > 2.5 && now - lastNote > 900) {
        lastNote = now;
        var n = document.createElement("span");
        n.className = "voyager__note";
        n.textContent = notes[Math.floor(Math.random() * notes.length)];
        n.style.left = (vPos.x + vSize() * 0.5) + "px";
        n.style.top = (vPos.y + vSize() * 0.5) + "px";
        n.style.fontSize = (14 + Math.random() * 14) + "px";
        document.body.appendChild(n);
        setTimeout(function () { n.remove(); }, 3300);
      }
      requestAnimationFrame(voyagerFrame);
    }
    requestAnimationFrame(voyagerFrame);
  }

  /* ---------------------------------------------------------------------
     PARALLAX ENGINE — any element with data-parallax="speed" drifts
     relative to scroll. Positive = slower (background), negative = faster.
     data-parallax-rotate optionally adds rotation.
     --------------------------------------------------------------------- */
  if (!reduceMotion) {
    var pxFrame = function () {
      var vh = window.innerHeight;
      document.querySelectorAll("[data-parallax]").forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute("data-parallax")) || 0.2;
        var centerOffset = (rect.top + rect.height / 2 - vh / 2);
        var shift = centerOffset * speed * -1;
        var rot = el.hasAttribute("data-parallax-rotate") ? centerOffset * 0.02 : 0;
        el.style.transform = "translate3d(0," + shift.toFixed(1) + "px,0)" + (rot ? " rotate(" + rot.toFixed(2) + "deg)" : "");
      });
      requestAnimationFrame(pxFrame);
    };
    requestAnimationFrame(pxFrame);
  }

  /* ---------------------------------------------------------------------
     HERO DEPTH — content, vinyl and ticker part ways as you scroll out
     --------------------------------------------------------------------- */
  var heroContent = document.querySelector(".hero__content");
  var heroVinyl = document.querySelector(".hero__vinyl");
  if (heroContent && !reduceMotion) {
    var heroY = 0;
    (function heroLoop() {
      var y = window.scrollY;
      if (y < window.innerHeight * 1.3) {
        heroY = lerp(heroY, y, 0.1);
        heroContent.style.transform = "translate3d(0," + (heroY * 0.28).toFixed(1) + "px,0)";
        heroContent.style.opacity = Math.max(0, 1 - heroY / (window.innerHeight * 0.85)).toFixed(3);
        if (heroVinyl) heroVinyl.style.transform = "translate3d(0," + (heroY * -0.15).toFixed(1) + "px,0)";
      }
      requestAnimationFrame(heroLoop);
    })();
  }

  /* ---------------------------------------------------------------------
     ACT NUMBERS — giant numerals slide horizontally with scroll
     --------------------------------------------------------------------- */
  if (!reduceMotion) {
    var actFrame = function () {
      document.querySelectorAll(".act__number").forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var progress = 1 - (rect.top + rect.height / 2) / window.innerHeight;
        el.style.transform = "translate(calc(-50% + " + ((progress - 0.5) * 120) + "px), -50%)";
      });
      requestAnimationFrame(actFrame);
    };
    requestAnimationFrame(actFrame);
  }

  /* ---------------------------------------------------------------------
     GALLERY: 3D tilt on hover
     --------------------------------------------------------------------- */
  if (finePointer && !reduceMotion) {
    document.addEventListener("mousemove", function (e) {
      var frame = e.target.closest && e.target.closest(".hallway__frame");
      if (!frame || frame.classList.contains("is-canvas")) return;
      var rect = frame.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;
      frame.style.setProperty("--tilt-y", (px * 10).toFixed(2) + "deg");
      frame.style.setProperty("--tilt-x", (py * -10).toFixed(2) + "deg");
    });
    document.addEventListener("mouseout", function (e) {
      var frame = e.target.closest && e.target.closest(".hallway__frame");
      if (!frame) return;
      if (e.relatedTarget && frame.contains(e.relatedTarget)) return;
      frame.style.setProperty("--tilt-y", "0deg");
      frame.style.setProperty("--tilt-x", "0deg");
    });
  }

  /* ---------------------------------------------------------------------
     LIGHTBOX — click a frame to enlarge with details + purchase
     --------------------------------------------------------------------- */
  var lightbox = document.querySelector("[data-lightbox]");
  if (lightbox) {
    var lbImg = lightbox.querySelector("[data-lightbox-img]");
    var lbTitle = lightbox.querySelector("[data-lightbox-title]");
    var lbMedium = lightbox.querySelector("[data-lightbox-medium]");
    var lbDesc = lightbox.querySelector("[data-lightbox-desc]");
    var lbPrice = lightbox.querySelector("[data-lightbox-price]");
    var lbBuy = lightbox.querySelector("[data-lightbox-buy]");
    var lbEyebrow = lightbox.querySelector("[data-lightbox-eyebrow]");
    var lastFocus = null;

    var openLightbox = function (trigger) {
      lastFocus = trigger;
      lbImg.src = trigger.getAttribute("data-lb-image") || "";
      lbImg.alt = trigger.getAttribute("data-lb-title") || "";
      lbTitle.textContent = trigger.getAttribute("data-lb-title") || "";
      lbMedium.textContent = trigger.getAttribute("data-lb-medium") || "";
      lbDesc.textContent = trigger.getAttribute("data-lb-desc") || "";
      lbPrice.textContent = trigger.getAttribute("data-lb-price") || "";
      lbEyebrow.textContent = trigger.getAttribute("data-lb-num") || "";
      var url = trigger.getAttribute("data-lb-url");
      var variantId = trigger.getAttribute("data-lb-variant");
      lbBuy.style.display = "";
      lbBuy.removeAttribute("data-variant");
      lbBuy.setAttribute("data-artwork", trigger.getAttribute("data-lb-image") || "");
      if (variantId) {
        lbBuy.href = url || "#";
        lbBuy.setAttribute("data-variant", variantId);
        lbBuy.textContent = "Add to cart \u2192";
      } else if (url) {
        lbBuy.href = url;
        lbBuy.textContent = "View this piece \u2192";
      } else {
        lbBuy.href = lbBuy.getAttribute("data-fallback-url") || "/collections/all";
        lbBuy.textContent = "Shop this piece \u2192";
      }
      lightbox.classList.add("is-open");
      document.body.style.overflow = "hidden";
      lightbox.querySelector(".lightbox__close").focus();
    };
    var closeLightbox = function () {
      lightbox.classList.remove("is-open");
      document.body.style.overflow = "";
      if (lastFocus) lastFocus.focus();
    };

    /* links that leave the lightbox (e.g. "Walk the full gallery") close it
       before the seamless navigation proceeds — the overlay lives outside
       the swappable page content, so it must come down on its own */
    lightbox.addEventListener("click", function (e) {
      var a = e.target.closest("a[href]");
      if (!a || a.hasAttribute("data-variant") || a.getAttribute("href") === "#") return;
      closeLightbox();
    });

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-lightbox-open]");
      if (trigger) openLightbox(trigger);
    });
    document.addEventListener("keydown", function (e) {
      var trigger = e.target.closest && e.target.closest("[data-lightbox-open]");
      if (trigger && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); openLightbox(trigger); }
    });
    lightbox.querySelector(".lightbox__close").addEventListener("click", closeLightbox);
    lightbox.addEventListener("click", function (e) { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && lightbox.classList.contains("is-open")) closeLightbox();
    });

    /* AJAX add-to-cart when a variant is attached */
    lbBuy.addEventListener("click", function (e) {
      var variant = lbBuy.getAttribute("data-variant");
      if (!variant) return; /* plain link behavior */
      e.preventDefault();
      var original = lbBuy.textContent;
      lbBuy.textContent = "Adding\u2026";
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: parseInt(variant, 10),
          quantity: 1,
          properties: {
            /* underscore-prefixed: hidden at checkout, used by the cart to
               keep the 3D-canvas illusion instead of the supplier mockup */
            _artwork: lbBuy.getAttribute("data-artwork") || "",
            _from: "/pages/art-gallery?piece=" + variant
          }
        })
      })
        .then(function (res) { if (!res.ok) throw new Error("add failed"); return res.json(); })
        .then(function () {
          lbBuy.textContent = "In your bag \u2713";
          if (window.__bsCartBadges) window.__bsCartBadges();
          setTimeout(function () { lbBuy.textContent = original; }, 2200);
        })
        .catch(function () {
          lbBuy.textContent = "Try again";
          setTimeout(function () { lbBuy.textContent = original; }, 2200);
        });
    });
  }

  /* ---------------------------------------------------------------------
     NAV PILL — hide on scroll down, show on scroll up; mark current page
     --------------------------------------------------------------------- */
  var pill = document.querySelector("[data-nav-pill]");
  if (pill) {
    var lastY = window.scrollY;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (y > lastY + 8 && y > 300) pill.classList.add("is-hidden");
      else if (y < lastY - 8) pill.classList.remove("is-hidden");
      lastY = y;
    }, { passive: true });

    var here = window.location.pathname;
    pill.querySelectorAll("a").forEach(function (a) {
      var href = a.getAttribute("href");
      if (href && href !== "/" && here.indexOf(href) === 0) a.classList.add("is-current");
      if (href === "/" && here === "/") a.classList.add("is-current");
    });
  }
})();

/* ==========================================================================
   V3 — LANDSCAPE ART, MULTI-PHOTO LIGHTBOX, CANVAS 3D, ON-YOUR-WALL
   ========================================================================== */
(function () {
  "use strict";

  /* -------------------------------------------------------------------
     Orientation-aware imagery: landscape art letterboxes instead of crops
     ------------------------------------------------------------------- */
  function markOrientation(img) {
    var apply = function () {
      if (img.naturalWidth > img.naturalHeight * 1.05) img.classList.add("is-landscape");
    };
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener("load", apply, { once: true });
  }
  document.querySelectorAll(".product-card__media img, [data-product-main-image], .product__thumbs img").forEach(markOrientation);
  window.__bsOrient = function (root) {
    (root || document).querySelectorAll(".product-card__media img, [data-product-main-image], .product__thumbs img").forEach(markOrientation);
  };

  /* -------------------------------------------------------------------
     Lightbox v3: multi-photo, flat/canvas modes, wall view launcher
     ------------------------------------------------------------------- */
  var lightbox = document.querySelector("[data-lightbox]");
  if (!lightbox) return;

  var lbImg = lightbox.querySelector("[data-lightbox-img]");
  var lbThumbs = lightbox.querySelector("[data-lightbox-thumbs]");
  var lbFrame = lightbox.querySelector(".lightbox__frame");
  var stage = lightbox.querySelector("[data-canvas3d-stage]");
  var modeBtns = lightbox.querySelectorAll("[data-lb-mode]");
  var wallOpenBtn = lightbox.querySelector("[data-wallview-open]");
  var currentImages = [];
  var currentIndex = 0;

  function setImage(i) {
    currentIndex = i;
    if (currentImages[i]) lbImg.src = currentImages[i];
    if (lbThumbs) {
      lbThumbs.querySelectorAll("img").forEach(function (t, ti) {
        t.classList.toggle("is-active", ti === i);
      });
    }
    if (stage && stage.classList.contains("is-active")) buildCanvas3d();
  }

  function populateImages(trigger) {
    var key = trigger.getAttribute("data-canvas-size");
    currentSizeIdx = (key && SIZE_BY_KEY[key] !== undefined) ? SIZE_BY_KEY[key] : null;
    currentImages = [];
    var json = trigger.getAttribute("data-lb-images");
    if (json) {
      try { currentImages = JSON.parse(json).filter(Boolean); } catch (e) { currentImages = []; }
    }
    if (!currentImages.length) {
      var single = trigger.getAttribute("data-lb-image");
      if (single) currentImages = [single];
    }
    if (lbThumbs) {
      lbThumbs.innerHTML = "";
      if (currentImages.length > 1) {
        currentImages.forEach(function (src, i) {
          var t = document.createElement("img");
          t.src = src;
          t.alt = "";
          t.addEventListener("click", function () { setImage(i); });
          lbThumbs.appendChild(t);
        });
      }
    }
    setImage(0);
  }

  /* Hook into every lightbox trigger (openLightbox in V2 sets the base
     fields; we extend with the photo set on the same click) */
  function lbEntryMode(trigger) {
    return trigger.hasAttribute("data-canvas-size") ? "canvas" : "flat";
  }
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-lightbox-open]");
    if (trigger) { populateImages(trigger); setLbMode(lbEntryMode(trigger)); }
  });
  document.addEventListener("keydown", function (e) {
    var trigger = e.target.closest && e.target.closest("[data-lightbox-open]");
    if (trigger && (e.key === "Enter" || e.key === " ")) { populateImages(trigger); setLbMode(lbEntryMode(trigger)); }
  });

  /* ----- flat / canvas mode ----- */
  function setLbMode(mode) {
    modeBtns.forEach(function (b) {
      b.classList.toggle("is-active", b.getAttribute("data-lb-mode") === mode);
    });
    var canvasMode = mode === "canvas";
    var stillMode = mode === "flat"; /* Print view: same canvas, parked still */
    var canvasish = canvasMode || stillMode;
    if (stage) {
      stage.classList.toggle("is-active", canvasish);
      stage.classList.toggle("is-still", stillMode);
    }
    if (sizesEl) sizesEl.classList.toggle("is-active", canvasMode);
    if (lbFrame) lbFrame.classList.toggle("is-canvas-mode", canvasish);
    if (canvasish) buildCanvas3d();
  }
  modeBtns.forEach(function (b) {
    b.addEventListener("click", function () { setLbMode(b.getAttribute("data-lb-mode")); });
  });

  /* ----- Canvas 3D: your three production sizes, true gallery-wrap ----- */
  var CANVAS_SIZES = [
    { label: "60\u00d760 cm \u00b7 24\u00d724\u2033", tag: "1:1", ratio: 1,       inchesW: 24 },
    { label: "60\u00d780 cm \u00b7 24\u00d732\u2033", tag: "3:4", ratio: 24 / 32, inchesW: 24 },
    { label: "60\u00d780 cm \u00b7 32\u00d724\u2033", tag: "4:3", ratio: 32 / 24, inchesW: 32 }
  ];
  /* Gelato framed canvas anatomy (inches): black rail face, reveal gap, box depth */
  var FRAME_IN = { face: 0.9, gap: 0.10, depth: 1.4 };
  function frameDims(size, outerW, imgRatio) {
    var ratio = size.ratio;
    /* the frame hangs to match the artwork: wide art on wide frames, tall on tall */
    if (imgRatio && imgRatio > 1.15 && ratio < 1) ratio = 1 / ratio;
    if (imgRatio && imgRatio < 0.87 && ratio > 1) ratio = 1 / ratio;
    var unit = outerW / (size.inchesW + 2 * FRAME_IN.face);
    var F = Math.max(8, Math.round(unit * FRAME_IN.face));
    var G = Math.max(2, Math.round(unit * FRAME_IN.gap));
    var artW = outerW - 2 * F;
    return {
      w: Math.round(outerW),
      h: Math.round(artW / ratio + 2 * F),
      d: Math.max(18, Math.round(unit * FRAME_IN.depth)),
      F: F,
      G: G
    };
  }
  var currentSizeIdx = null; /* null = auto-pick from artwork orientation */
  var SIZE_BY_KEY = { "1x1": 0, "5x7": 1, "3x4": 2, "2x3": 1, "3x2": 2 }; /* legacy keys map to nearest Gelato size */
  var sizesEl = lightbox.querySelector("[data-canvas-sizes]");

  function pickDefaultSize(imgRatio) {
    if (imgRatio > 1.15 || imgRatio < 0.87) return 2; /* non-square -> 24x32 flagship */
    return 0;                                          /* square -> 12x12 */
  }

  function canvasMarkup(src, w, h, d, extraClass, F, G) {
    /* Gelato float frame in TRUE 3D: black rails on the lip plane, the canvas
       genuinely recessed behind them, and the print's wrap on the canvas's
       real side walls — so perspective occludes the far reveal and opens the
       near one, exactly like the physical object. */
    F = F || Math.max(8, Math.round(w * 0.06));
    G = G || Math.max(2, Math.round(F * 0.12));
    var halfW = w / 2, halfH = h / 2, halfD = d / 2;
    /* float-mount recess: shallow, like the reference — the canvas face rides
       just behind the lip, so the piece reads forward, not sunken */
    var R  = Math.max(3, Math.round(F * 0.18));
    R = Math.min(R, Math.max(3, Math.round(d * 0.3)));
    var Wd = Math.min(R + 5, Math.max(4, Math.round(d * 0.6)));
    var winW = w - 2 * F, winH = h - 2 * F;      /* window inside the rails */
    var artW = winW - 2 * G, artH = winH - 2 * G;
    var zArt = halfD - R;                        /* canvas face plane */
    var zc = zArt - Wd / 2;                      /* wrap walls' z-center */
    var inX = halfW - F - G, inY = halfH - F - G;
    var bg = "url('" + src + "')";
    var wrapBG = ";background-image:" + bg + ";background-size:" + artW + "px " + artH + "px;";
    return (
      '<div class="canvas3d ' + (extraClass || "") + '" style="width:' + w + 'px;height:' + h + 'px;">' +
      '  <div class="canvas3d__shadow" style="width:' + w + 'px;height:' + h + 'px;top:0;left:0;transform:translateZ(' + (-halfD - 1) + 'px);"></div>' +
      /* SOLID BACK SEAL: a full-size black plate inside the box — no sightline
         through any reveal can ever reach the world behind the piece */
      '  <div class="canvas3d__seal" style="width:' + w + 'px;height:' + h + 'px;left:0;top:0;transform:translateZ(' + Math.max(-halfD + 1, zArt - Wd - 4) + 'px);"></div>' +
      /* the dark well behind everything inside the window */
      '  <div class="canvas3d__well" style="width:' + winW + 'px;height:' + winH + 'px;left:' + F + 'px;top:' + F + 'px;transform:translateZ(' + Math.max(-halfD + 2, zArt - Wd - 2) + 'px);"></div>' +
      /* the recessed canvas face */
      '  <div class="canvas3d__art" style="width:' + artW + 'px;height:' + artH + 'px;left:' + (F + G) + 'px;top:' + (F + G) + 'px;transform:translateZ(' + zArt + 'px);background-image:' + bg + ';background-size:cover;background-position:center;"></div>' +
      /* the print wrapping the canvas sides — perspective decides what you see */
      '  <div class="canvas3d__wrapedge" style="width:' + Wd + 'px;height:' + artH + 'px;left:' + (halfW - Wd / 2) + 'px;top:' + (F + G) + 'px;transform:translateZ(' + zc + 'px) rotateY(-90deg) translateZ(' + inX + 'px);background-position:0 0' + wrapBG + '"></div>' +
      '  <div class="canvas3d__wrapedge" style="width:' + Wd + 'px;height:' + artH + 'px;left:' + (halfW - Wd / 2) + 'px;top:' + (F + G) + 'px;transform:translateZ(' + zc + 'px) rotateY(90deg) translateZ(' + inX + 'px);background-position:' + (-(artW - Wd)) + 'px 0' + wrapBG + '"></div>' +
      '  <div class="canvas3d__wrapedge canvas3d__wrapedge--h" style="width:' + artW + 'px;height:' + Wd + 'px;left:' + (F + G) + 'px;top:' + (halfH - Wd / 2) + 'px;transform:translateZ(' + zc + 'px) rotateX(90deg) translateZ(' + inY + 'px);background-position:0 0' + wrapBG + '"></div>' +
      '  <div class="canvas3d__wrapedge canvas3d__wrapedge--h canvas3d__wrapedge--b" style="width:' + artW + 'px;height:' + Wd + 'px;left:' + (F + G) + 'px;top:' + (halfH - Wd / 2) + 'px;transform:translateZ(' + zc + 'px) rotateX(-90deg) translateZ(' + inY + 'px);background-position:0 ' + (-(artH - Wd)) + 'px' + wrapBG + '"></div>' +
      /* the frame's four rails on the lip plane */
      '  <div class="canvas3d__front" style="position:absolute;top:0;left:0;width:' + w + 'px;height:' + h + 'px;transform:translateZ(' + halfD + 'px);">' +
      '    <span class="canvas3d__rail canvas3d__rail--t" style="left:0;top:0;width:' + w + 'px;height:' + F + 'px;"></span>' +
      '    <span class="canvas3d__rail canvas3d__rail--b" style="left:0;bottom:0;width:' + w + 'px;height:' + F + 'px;"></span>' +
      '    <span class="canvas3d__rail canvas3d__rail--l" style="left:0;top:' + F + 'px;width:' + F + 'px;height:' + winH + 'px;"></span>' +
      '    <span class="canvas3d__rail canvas3d__rail--r" style="right:0;top:' + F + 'px;width:' + F + 'px;height:' + winH + 'px;"></span>' +
      "  </div>" +
      '  <div class="canvas3d__face canvas3d__side canvas3d__side--r" style="width:' + d + 'px;height:' + h + 'px;top:0;left:' + (halfW - halfD) + 'px;transform:rotateY(90deg) translateZ(' + halfW + 'px);"></div>' +
      '  <div class="canvas3d__face canvas3d__side canvas3d__side--l" style="width:' + d + 'px;height:' + h + 'px;top:0;left:' + (halfW - halfD) + 'px;transform:rotateY(-90deg) translateZ(' + halfW + 'px);"></div>' +
      '  <div class="canvas3d__face canvas3d__top" style="width:' + w + 'px;height:' + d + 'px;left:0;top:' + (halfH - halfD) + 'px;transform:rotateX(90deg) translateZ(' + halfH + 'px);"></div>' +
      '  <div class="canvas3d__face canvas3d__bottom" style="width:' + w + 'px;height:' + d + 'px;left:0;top:' + (halfH - halfD) + 'px;transform:rotateX(-90deg) translateZ(' + halfH + 'px);"></div>' +
      "</div>");
  }

  function buildCanvas3d() {
    if (!stage) return;
    var src = currentImages[currentIndex];
    if (!src) return;
    var probe = new Image();
    probe.onload = function () {
      if (currentSizeIdx === null) {
        currentSizeIdx = pickDefaultSize(probe.naturalWidth / probe.naturalHeight);
      }
      syncSizeChips();
      var size = CANVAS_SIZES[currentSizeIdx];
      var imgR = probe.naturalWidth / probe.naturalHeight;
      var maxW = Math.min(560, window.innerWidth * 0.72);
      var maxH = Math.min(420, window.innerHeight * 0.5);
      var fd = frameDims(size, maxW, imgR);
      if (fd.h > maxH) fd = frameDims(size, Math.max(120, Math.round(maxW * (maxH / fd.h))), imgR);
      stage.innerHTML = canvasMarkup(src, fd.w, fd.h, fd.d, "", fd.F, fd.G);
    };
    probe.src = src;
  }

  function syncSizeChips() {
    if (!sizesEl) return;
    sizesEl.querySelectorAll("[data-canvas-size]").forEach(function (b) {
      b.classList.toggle("is-selected", parseInt(b.getAttribute("data-canvas-size"), 10) === currentSizeIdx);
    });
  }
  if (sizesEl) {
    sizesEl.addEventListener("click", function (e) {
      var chip = e.target.closest("[data-canvas-size]");
      if (!chip) return;
      currentSizeIdx = parseInt(chip.getAttribute("data-canvas-size"), 10);
      syncSizeChips();
      buildCanvas3d();
      if (wallview && wallview.classList.contains("is-open")) buildWallCanvas();
    });
  }

  /* ----- Hallway: every uploaded artwork renders as a wrapped 3D canvas ----- */
  function canvasifyHallway(root) {
    (root || document).querySelectorAll(".hallway__frame[data-canvas-size]").forEach(function (frame) {
      var key = frame.getAttribute("data-canvas-size");
      var idx = SIZE_BY_KEY[key] !== undefined ? SIZE_BY_KEY[key] : 1;
      var size = CANVAS_SIZES[idx];
      var src = frame.getAttribute("data-lb-image");
      if (!src) {
        var flat = frame.querySelector("img");
        if (flat) src = flat.currentSrc || flat.src;
      }
      if (!src) return;
      var w = Math.round(frame.clientWidth ? frame.clientWidth - 20 : 420);
      if (w < 120) w = 420;
      var fd = frameDims(size, w);
      var h = fd.h, d = fd.d;
      var wrap = frame.querySelector(".hallway__canvaswrap");
      if (wrap && wrap.dataset.w === String(w)) return; /* unchanged — keep the living animation */
      if (!wrap) {
        wrap = document.createElement("div");
        wrap.className = "hallway__canvaswrap";
        var flatImg = frame.querySelector("img");
        if (flatImg) flatImg.style.display = "none";
        var ph = frame.querySelector(".hallway__frame-placeholder");
        if (ph) ph.style.display = "none";
        frame.insertBefore(wrap, frame.firstChild);
      }
      wrap.dataset.w = String(w);
      wrap.style.height = (h + d * 2) + "px";
      wrap.innerHTML = canvasMarkup(src, fd.w, fd.h, fd.d, "canvas3d--hall", fd.F, fd.G);
      /* cache per-canvas motion constants so the animation loop never
         touches the DOM tree during scroll (no closest(), no sibling math) */
      var cv = wrap.querySelector(".canvas3d--hall");
      if (cv) {
        var piece = frame.closest("[data-hallway-piece]");
        var even = false, order = 0;
        if (piece && piece.parentElement) {
          var sibs = Array.prototype.filter.call(piece.parentElement.children, function (el) {
            return el.hasAttribute && el.hasAttribute("data-hallway-piece");
          });
          order = sibs.indexOf(piece);
          even = order % 2 === 1;
        }
        cv.dataset.by = even ? "22" : "-22";
        cv.dataset.ph = (order * 1.9).toFixed(2);
        cv.classList.add(even ? "canvas3d--hall-r" : "canvas3d--hall-l");
        cv.style.animationDelay = "-" + (order * 1.7).toFixed(1) + "s";
        cv.dataset.vis = "1";
        if ("IntersectionObserver" in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { en.target.dataset.vis = en.isIntersecting ? "1" : "0"; });
          }, { rootMargin: "120px" }).observe(cv);
        }
      }
    });
  }
  function buildProductCanvas(root) {
    (root || document).querySelectorAll("[data-product-canvas]").forEach(function (stg) {
      var key = stg.getAttribute("data-canvas-size") || "3x2";
      var idx = SIZE_BY_KEY[key] !== undefined ? SIZE_BY_KEY[key] : 1;
      var size = CANVAS_SIZES[idx];
      var src = stg.getAttribute("data-src");
      if (!src) return;
      if (stg.dataset.built === src) return;
      stg.dataset.built = src;
      var w = Math.round(Math.min(stg.clientWidth - 30 || 520, 560));
      if (w < 200) w = 420;
      var fd = frameDims(size, w);
      stg.style.height = (fd.h + fd.d * 2 + 30) + "px";
      stg.innerHTML = canvasMarkup(src, fd.w, fd.h, fd.d, "canvas3d--product", fd.F, fd.G);
    });
  }
  window.__bsProductCanvas = buildProductCanvas;
  buildProductCanvas(document);

  function buildProductCanvas(root) {
    (root || document).querySelectorAll("[data-product-canvas]").forEach(function (stg) {
      var key = stg.getAttribute("data-canvas-size") || "3x2";
      var idx = SIZE_BY_KEY[key] !== undefined ? SIZE_BY_KEY[key] : 1;
      var size = CANVAS_SIZES[idx];
      var src = stg.getAttribute("data-src");
      if (!src || stg.dataset.built === src) return;
      stg.dataset.built = src;
      var w = Math.round(Math.min((stg.clientWidth || 520) - 30, 560));
      if (!stg.clientWidth) w = 420;
      if (w < 60) w = 90;
      var fd = frameDims(size, w);
      stg.style.height = (fd.h + fd.d * 2 + 30) + "px";
      stg.innerHTML = canvasMarkup(src, fd.w, fd.h, fd.d, "canvas3d--product", fd.F, fd.G);
    });
  }
  window.__bsProductCanvas = buildProductCanvas;
  buildProductCanvas(document);

  window.__bsCanvasify = canvasifyHallway;
  canvasifyHallway(document);

  /* Motion engine: one buttery system for every hallway canvas.
     Desktop — the canvas turns softly toward your cursor and settles back.
     Mobile  — it rotates with scroll: angled in the distance, opening up
     as it reaches the center of the screen, like walking past it. */
  (function hallwayMotion() {
    var hoverFine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    /* Touch devices: iOS throttles JS frames during scroll, so any JS-driven
       motion hitches mid-scroll. Mobile sway is pure CSS animation instead
       (compositor thread — runs at full frame rate through any scroll).
       This engine only drives the desktop cursor-follow. */
    if (!hoverFine) return;

    if (hoverFine) {
      document.addEventListener("mousemove", function (e) {
        var frame = e.target.closest && e.target.closest(".hallway__frame.is-canvas");
        document.querySelectorAll(".hallway__frame.is-canvas").forEach(function (f) {
          if (f !== frame) { delete f.dataset.hx; delete f.dataset.hy; }
        });
        if (!frame) return;
        var r = frame.getBoundingClientRect();
        frame.dataset.hx = ((e.clientX - r.left) / r.width - 0.5).toFixed(3);
        frame.dataset.hy = ((e.clientY - r.top) / r.height - 0.5).toFixed(3);
      });
    }

    function frameLoop() {
      var now = performance.now() / 1000;
      document.querySelectorAll(".canvas3d--hall").forEach(function (cv) {
        if (cv.dataset.vis === "0") return; /* off-screen: zero work */
        var baseY = parseFloat(cv.dataset.by || "-22");
        var phase = parseFloat(cv.dataset.ph || "0");
        var tY, tX;

        if (hoverFine) {
          var frame = cv.parentElement && cv.parentElement.parentElement;
          if (frame && frame.dataset && frame.dataset.hx !== undefined) {
            /* desktop: lean toward the cursor from the base pose */
            var hx = parseFloat(frame.dataset.hx), hy = parseFloat(frame.dataset.hy);
            tY = baseY * 0.3 + hx * 26;
            tX = 4 + hy * -14;
          } else {
            tY = baseY;
            tX = 4;
          }
        } else {
          /* mobile: autonomous slow sway — decoupled from scroll */
          tY = baseY * 0.7 + Math.sin(now * 0.45 + phase) * 11;
          tX = 4 + Math.sin(now * 0.3 + phase * 1.4) * 4;
        }

        var cy = parseFloat(cv.dataset.cy || baseY);
        var cx = parseFloat(cv.dataset.cx || 4);
        cy += (tY - cy) * 0.07;
        cx += (tX - cx) * 0.07;
        cv.dataset.cy = cy.toFixed(2);
        cv.dataset.cx = cx.toFixed(2);
        cv.style.transform = "rotateY(" + cy.toFixed(2) + "deg) rotateX(" + cx.toFixed(2) + "deg)";
      });
      requestAnimationFrame(frameLoop);
    }
    requestAnimationFrame(frameLoop);
  })();
  var canvasifyT = null;
  var canvasifyW = window.innerWidth;
  window.addEventListener("resize", function () {
    /* iOS fires resize when the Safari toolbar shows/hides on scroll
       direction changes — height-only; rebuilding then restarts every
       canvas animation and reads as jerking. Only rebuild on width change. */
    if (window.innerWidth === canvasifyW) return;
    canvasifyW = window.innerWidth;
    clearTimeout(canvasifyT);
    canvasifyT = setTimeout(function () { canvasifyHallway(document); }, 200);
  });

  /* ----- Print view detail zoom (Amazon-style) ----- */
  (function detailZoom() {
    if (!lbFrame || !lbImg) return;
    var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    lbFrame.classList.add("has-zoom");
    lbFrame.setAttribute("data-cursor", "Zoom");

    function setOrigin(clientX, clientY) {
      var r = lbFrame.getBoundingClientRect();
      var x = ((clientX - r.left) / r.width) * 100;
      var y = ((clientY - r.top) / r.height) * 100;
      lbImg.style.transformOrigin = Math.max(0, Math.min(100, x)) + "% " + Math.max(0, Math.min(100, y)) + "%";
    }

    if (fine) {
      lbFrame.addEventListener("mouseenter", function () { lbFrame.classList.add("is-zooming"); });
      lbFrame.addEventListener("mousemove", function (e) { setOrigin(e.clientX, e.clientY); });
      lbFrame.addEventListener("mouseleave", function () {
        lbFrame.classList.remove("is-zooming");
        lbImg.style.transformOrigin = "50% 50%";
      });
    } else {
      /* touch: tap toggles zoom, drag pans while zoomed */
      var zoomed = false;
      lbFrame.addEventListener("click", function (e) {
        zoomed = !zoomed;
        lbFrame.classList.toggle("is-zooming", zoomed);
        if (zoomed) setOrigin(e.clientX || (window.innerWidth / 2), e.clientY || (window.innerHeight / 2));
        else lbImg.style.transformOrigin = "50% 50%";
      });
      lbFrame.addEventListener("touchmove", function (e) {
        if (!zoomed || !e.touches.length) return;
        e.preventDefault();
        setOrigin(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: false });
    }
  })();

  /* ----- Print view loupe: brass lens; magnified view shows the art plus the
           reveal gap and black frame at the true fold lines ----- */
  (function loupe() {
    if (!stage) return;
    var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    var LIFT = fine ? 0 : 110;
    var ZOOM = 2.6;
    var lens = null;
    function ensureLens() {
      if (lens && lens.isConnected) return lens;
      lens = document.createElement("div");
      lens.className = "canvas-loupe";
      stage.appendChild(lens);
      return lens;
    }
    function showAt(clientX, clientY) {
      var artEl = stage.querySelector(".canvas3d__art") || stage.querySelector(".canvas3d__front") || stage.querySelector(".canvas3d");
      var src = currentImages && currentImages[currentIndex];
      if (!artEl || !src) return;
      var r = artEl.getBoundingClientRect();
      var x = Math.max(r.left, Math.min(r.right, clientX));
      var y = Math.max(r.top, Math.min(r.bottom, clientY));
      var l = ensureLens();
      var L = l.offsetWidth || 190;
      var sz = CANVAS_SIZES[currentSizeIdx !== null ? currentSizeIdx : 1];
      var unit = r.width / sz.inchesW;
      var Fz = Math.round(Math.max(8, unit * FRAME_IN.face) * ZOOM);
      var Gz = Math.round(Math.max(2, unit * FRAME_IN.gap) * ZOOM);
      var key = src + "|" + Math.round(r.width) + "|" + currentSizeIdx;
      var AW = Math.round(r.width * ZOOM);
      var AH = Math.round(r.height * ZOOM);
      if (l.dataset.key !== key) {
        l.dataset.key = key;
        l.innerHTML =
          '<div class="canvas-loupe__scene" style="width:' + (AW + 2 * (Fz + Gz)) + "px;height:" + (AH + 2 * (Fz + Gz)) + 'px;">' +
            '<i class="loupe-rail" style="inset:0;border-width:' + Fz + 'px;"></i>' +
            '<i class="loupe-gap" style="inset:' + Fz + 'px;border-width:' + Gz + 'px;"></i>' +
            '<span class="loupe-art" style="left:' + (Fz + Gz) + "px;top:" + (Fz + Gz) + "px;width:" + AW + "px;height:" + AH + "px;" +
              "background-image:url('" + src + "');background-size:" + AW + "px " + AH + 'px;"></span>' +
          "</div>";
      }
      var scene = l.querySelector(".canvas-loupe__scene");
      if (scene) {
        scene.style.transform =
          "translate(" + (-((Fz + Gz) + (x - r.left) * ZOOM - L / 2)) + "px, " +
                         (-((Fz + Gz) + (y - r.top) * ZOOM - L / 2)) + "px)";
      }
      var sr = stage.getBoundingClientRect();
      l.style.left = (x - sr.left) + "px";
      l.style.top = (y - sr.top - LIFT) + "px";
      l.classList.add("is-on");
      stage.classList.add("is-lens", "has-inspected");
    }
    function hide() {
      if (lens && lens.isConnected) lens.classList.remove("is-on");
      stage.classList.remove("is-lens");
    }
    if (fine) {
      stage.addEventListener("mousemove", function (e) {
        if (stage.classList.contains("is-still")) showAt(e.clientX, e.clientY);
      });
      stage.addEventListener("mouseleave", hide);
    } else {
      stage.addEventListener("touchstart", function (e) {
        if (!stage.classList.contains("is-still") || !e.touches.length) return;
        showAt(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      stage.addEventListener("touchmove", function (e) {
        if (!stage.classList.contains("is-still") || !e.touches.length) return;
        e.preventDefault();
        showAt(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: false });
      stage.addEventListener("touchend", hide);
      stage.addEventListener("touchcancel", hide);
    }
  })();

  /* ----- Lightbox canvas motion: continuous idle drift, pointer takes over
           seamlessly (one loop, one easing — no animation handoffs) ----- */
  (function stageMotion() {
    if (!stage) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var hoverFine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    var pointerOn = false;
    var pt = { x: 4, y: -22 };
    var cur = { x: 4, y: -22 };

    if (hoverFine) {
      stage.addEventListener("mousemove", function (e) {
        var r = stage.getBoundingClientRect();
        pointerOn = true;
        pt.y = ((e.clientX - r.left) / r.width - 0.5) * 64;
        pt.x = ((e.clientY - r.top) / r.height - 0.5) * -30;
      });
      stage.addEventListener("mouseleave", function () { pointerOn = false; });
    }

    (function loop() {
      var cv = stage.querySelector(".canvas3d");
      if (cv && stage.classList.contains("is-active") && !stage.classList.contains("is-still")) {
        var tx, ty;
        if (pointerOn && !reduce) {
          tx = pt.x; ty = pt.y;
        } else if (!reduce) {
          /* slow figure-of-breath idle drift */
          var t = performance.now() / 1000;
          ty = -20 + Math.sin(t * 0.45) * 10;
          tx = 4 + Math.sin(t * 0.32 + 1.7) * 4;
        } else {
          tx = 4; ty = -22;
        }
        cur.x += (tx - cur.x) * 0.06;
        cur.y += (ty - cur.y) * 0.06;
        cv.style.transform = "rotateY(" + cur.y.toFixed(2) + "deg) rotateX(" + cur.x.toFixed(2) + "deg)";
      }
      requestAnimationFrame(loop);
    })();
  })();

  /* -------------------------------------------------------------------
     On-your-wall camera view (pseudo-AR): live feed + draggable artwork
     ------------------------------------------------------------------- */
  var wallview = document.querySelector("[data-wallview]");
  if (wallOpenBtn && wallview) {
    var wvVideo = wallview.querySelector("video");
    var wvArt = wallview.querySelector("[data-wallview-art]");
    var wvClose = wallview.querySelector("[data-wallview-close]");
    var wvScale = wallview.querySelector("[data-wallview-scale]");
    var wvStream = null;

    function buildWallCanvas() {
      /* always project the artwork itself (photo 1), never a lifestyle shot */
      var src = currentImages[0] || lbImg.src;
      if (!src) return;
      var probe = new Image();
      probe.onload = function () {
        if (currentSizeIdx === null) {
          currentSizeIdx = pickDefaultSize(probe.naturalWidth / probe.naturalHeight);
          syncSizeChips();
        }
        var size = CANVAS_SIZES[currentSizeIdx];
        var vw = wvScale ? parseFloat(wvScale.value) : 55;
        var w = Math.round(window.innerWidth * (vw / 100));
        var fd = frameDims(size, w, probe.naturalWidth / probe.naturalHeight);
        wvArt.style.width = fd.w + "px";
        wvArt.style.height = fd.h + "px";
        wvArt.innerHTML =
          '<div class="canvas3d-wallwrap" style="perspective:1100px;width:100%;height:100%;">' +
          canvasMarkup(src, fd.w, fd.h, fd.d, "canvas3d--wall", fd.F, fd.G) +
          "</div>";
      };
      probe.src = src;
    }

    function openWall() {
      wallview.classList.remove("has-error");
      wallview.classList.add("is-open");
      buildWallCanvas();
      document.body.style.overflow = "hidden";
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        wallview.classList.add("has-error");
        return;
      }
      navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" }, audio: false })
        .then(function (stream) {
          wvStream = stream;
          wvVideo.srcObject = stream;
          wvVideo.play().catch(function () {});
        })
        .catch(function () { wallview.classList.add("has-error"); });
    }
    function closeWall() {
      wallview.classList.remove("is-open");
      if (wvStream) { wvStream.getTracks().forEach(function (t) { t.stop(); }); wvStream = null; }
      wvVideo.srcObject = null;
      /* return scroll lock to the lightbox, which is still open beneath */
      document.body.style.overflow = "hidden";
    }
    wallOpenBtn.addEventListener("click", openWall);
    wvClose.addEventListener("click", closeWall);

    /* drag to place */
    var dragging = false, startX = 0, startY = 0, artX = 0, artY = 0;
    wvArt.addEventListener("pointerdown", function (e) {
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      var r = wvArt.getBoundingClientRect();
      artX = r.left + r.width / 2; artY = r.top + r.height / 2;
      wvArt.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    wvArt.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var nx = artX + (e.clientX - startX);
      var ny = artY + (e.clientY - startY);
      wvArt.style.left = nx + "px";
      wvArt.style.top = ny + "px";
    });
    wvArt.addEventListener("pointerup", function () { dragging = false; });
    wvArt.addEventListener("pointercancel", function () { dragging = false; });

    /* size on the wall */
    if (wvScale) {
      wvScale.addEventListener("input", buildWallCanvas);
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && wallview.classList.contains("is-open")) closeWall();
    });
  }
})();

/* ==========================================================================
   SHOPIFY THEME EDITOR SUPPORT
   The editor re-renders a section's HTML after every setting change.
   Freshly rendered elements never met our scroll-reveal observer, so they
   sat invisible at opacity 0 — "the whole player disappeared". These
   lifecycle hooks re-arm everything the moment the editor swaps a section.
   ========================================================================== */
(function () {
  "use strict";

  function reviveSection(root) {
    root = root || document;
    /* reveal-hidden content becomes visible immediately */
    root.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-visible"); });
    /* re-arm any music player in the re-rendered markup */
    if (window.__bsInitPlayer) {
      root.querySelectorAll("[data-player]").forEach(window.__bsInitPlayer);
    }
    /* hallway pieces render dim until focused; wake them in the editor */
    root.querySelectorAll("[data-hallway-piece]").forEach(function (el) { el.classList.add("is-focused"); });
    if (window.__bsCanvasify) window.__bsCanvasify(root);
    if (window.__bsProductCanvas) window.__bsProductCanvas(root);
    if (window.__bsOpenPiece) window.__bsOpenPiece();
    if (window.__bsProductCanvas) window.__bsProductCanvas(root);
  }

  document.addEventListener("shopify:section:load", function (e) { reviveSection(e.target); });
  document.addEventListener("shopify:section:select", function (e) { reviveSection(e.target); });
  document.addEventListener("shopify:block:select", function (e) { reviveSection(e.target.closest(".shopify-section") || document); });

  /* Inside the editor, never leave anything reveal-hidden at all */
  if (window.Shopify && window.Shopify.designMode) {
    reviveSection(document);
  }
})();

/* ==========================================================================
   V4 — CONTINUOUS PLAYBACK
   Global audio lives in the site shell. Internal navigation swaps page
   content without a reload, so the music never stops. A docked mini player
   follows the listener everywhere; hard reloads resume where they left off.
   ========================================================================== */
(function () {
  "use strict";

  var audio = document.querySelector("[data-global-audio]");
  if (!audio) return;

  /* ---------------- Mini player ---------------- */
  var bar = document.querySelector("[data-miniplayer]");
  var barDisc = document.querySelector("[data-miniplayer-disc]");
  var barTitle = document.querySelector("[data-miniplayer-title]");
  var barToggle = document.querySelector("[data-miniplayer-toggle]");
  var MICON_PLAY = '<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
  var MICON_PAUSE = '<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';

  function playingNow() {
    if (window.__bsMode === "sc") return !!window.__bsNowPlaying;
    return !audio.paused && !audio.ended;
  }
  function syncBar() {
    if (!bar) return;
    var hasTrack = !!audio.dataset.title;
    bar.classList.toggle("is-visible", hasTrack);
    if (!hasTrack) return;
    if (barTitle) barTitle.textContent = audio.dataset.title;
    var playing = playingNow();
    if (barToggle) {
      barToggle.innerHTML = playing ? MICON_PAUSE : MICON_PLAY;
      barToggle.setAttribute("aria-label", playing ? "Pause" : "Play");
    }
    if (barDisc) barDisc.classList.toggle("is-playing", playing);
  }
  audio.addEventListener("play", function () { window.__bsNowPlaying = true; window.__bsMode = "file"; syncBar(); });
  audio.addEventListener("pause", function () { if (window.__bsMode === "file") window.__bsNowPlaying = false; syncBar(); });
  audio.addEventListener("ended", function () { if (window.__bsMode === "file") window.__bsNowPlaying = false; syncBar(); });
  document.addEventListener("bs:state", syncBar);
  if (barToggle) {
    barToggle.addEventListener("click", function () {
      if (window.__bsMode === "sc" && window.__bsScEnsure) {
        window.__bsScEnsure(window.__bsScUrl || audio.dataset.scurl, function (w) {
          if (playingNow()) w.pause(); else w.play();
        });
        return;
      }
      if (audio.paused) audio.play().catch(function () {});
      else audio.pause();
    });
  }
  syncBar();

  /* ---------------- Resume after a hard reload ---------------- */
  var STORE_KEY = "bs-now-spinning";
  window.addEventListener("pagehide", function () {
    if (!audio.dataset.title) return;
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        mode: window.__bsMode || "file",
        src: audio.src,
        scurl: window.__bsScUrl || audio.dataset.scurl || "",
        title: audio.dataset.title,
        artist: audio.dataset.artist || "",
        time: audio.currentTime || 0,
        playing: playingNow()
      }));
    } catch (err) {}
  });
  (function restore() {
    if (audio.dataset.title) return; /* something already loaded this page */
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || "null"); } catch (err) {}
    if (!saved) return;
    if (saved.mode === "sc" && saved.scurl) {
      audio.dataset.title = saved.title || "";
      audio.dataset.artist = saved.artist || "";
      audio.dataset.scurl = saved.scurl;
      window.__bsMode = "sc";
      window.__bsScUrl = saved.scurl;
      window.__bsNowPlaying = false;
      syncBar(); /* dock appears, primed to resume on tap */
      return;
    }
    if (!saved.src) return;
    audio.src = saved.src;
    audio.dataset.title = saved.title || "";
    audio.dataset.artist = saved.artist || "";
    audio.addEventListener("loadedmetadata", function seekOnce() {
      audio.removeEventListener("loadedmetadata", seekOnce);
      if (saved.time && isFinite(saved.time)) audio.currentTime = saved.time;
    });
    if (saved.playing) {
      /* browsers may block sound-on autoplay without a gesture;
         if blocked, the mini player waits with a ready play button */
      audio.play().catch(function () {});
    }
    syncBar();
  })();

  /* ---------------- Seamless internal navigation ---------------- */
  if (window.Shopify && window.Shopify.designMode) return; /* never inside the editor */
  if (!window.history || !window.history.pushState || !window.DOMParser) return;

  var BLOCK = ["/checkout", "/checkouts", "/account", "/admin", "/cdn", "/apps", "/policies"];

  function pjaxable(a) {
    if (!a) return false;
    var href = a.getAttribute("href") || "";
    if (!href || href.charAt(0) === "#") return false;
    if (a.target && a.target !== "_self") return false;
    if (a.hasAttribute("download") || a.getAttribute("rel") === "external") return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return false; }
    if (url.origin !== location.origin) return false;
    for (var i = 0; i < BLOCK.length; i++) {
      if (url.pathname.indexOf(BLOCK[i]) === 0) return false;
    }
    /* same-page anchors scroll natively */
    if (url.pathname === location.pathname && url.hash) return false;
    return url;
  }

  function reviveSwapped(root) {
    /* Overlays live OUTSIDE the swapped content, so nothing about a page
       change takes them down. If a navigation starts while the nav sheet or a
       lightbox is open — a tap on the menu carousel does exactly that — the
       open class and its scroll lock survive into the new page and the header
       stops responding. Clear them first, before __bsOpenPiece below gets its
       chance to reopen a lightbox deliberately. */
    var sheet = document.querySelector("[data-mobile-nav]");
    if (sheet) sheet.classList.remove("is-open");
    var burger = document.querySelector("[data-menu-toggle]");
    if (burger) burger.setAttribute("aria-expanded", "false");
    document.body.classList.remove("menu-open");
    var lb = document.querySelector(".lightbox.is-open");
    if (lb) lb.classList.remove("is-open");
    document.body.style.overflow = "";

    if (window.__bsHeaderTone) window.__bsHeaderTone(); /* new room, new floor colour */
    if (window.__bsReveal) window.__bsReveal(root);
    if (window.__bsInitPlayer) root.querySelectorAll("[data-player]").forEach(window.__bsInitPlayer);
    if (window.__bsOrient) window.__bsOrient(root);
    if (window.__bsCanvasify) window.__bsCanvasify(root);
    if (window.__bsProductCanvas) window.__bsProductCanvas(root);
    if (window.__bsFocusHallway) window.__bsFocusHallway(); /* pieces were stuck dim until first scroll */
    if (window.__bsPrimeVariants) window.__bsPrimeVariants(root);
    if (window.__bsApplyDept) window.__bsApplyDept();
    if (window.__bsOpenPiece) window.__bsOpenPiece(); /* ?piece= deep links open after seamless arrivals */
    if (window.__bsSpotlight) window.__bsSpotlight();
    if (window.__bsWipeOut) window.__bsWipeOut();
    /* nav pill current-page highlight */
    var pill = document.querySelector("[data-nav-pill]");
    if (pill) {
      var here = window.location.pathname;
      pill.querySelectorAll("a").forEach(function (a) {
        a.classList.remove("is-current");
        var href = a.getAttribute("href");
        if (href && href !== "/" && here.indexOf(href.split("#")[0]) === 0 && href.split("#")[0] !== "") a.classList.add("is-current");
        if (href === "/" && here === "/") a.classList.add("is-current");
      });
    }
  }

  var navigating = false;
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";
  var prefetchCache = new Map();
  function fetchPage(href) {
    return fetch(href, { credentials: "same-origin", headers: { "X-Requested-With": "bs-pjax" } })
      .then(function (res) {
        if (!res.ok) throw new Error("nav failed");
        return res.text();
      });
  }
  if (window.matchMedia("(hover: hover)").matches) {
    document.addEventListener("mouseover", function (e) {
      var a = e.target.closest && e.target.closest("a[href]");
      var url = pjaxable(a);
      if (!url || prefetchCache.has(url.href) || prefetchCache.size > 8) return;
      prefetchCache.set(url.href, fetchPage(url.href).catch(function () { prefetchCache.delete(url.href); }));
    }, { passive: true });
  }

  function go(url, push) {
    if (navigating) return;
    navigating = true;
    try { sessionStorage.setItem("bs-scroll:" + lastPath, String(window.scrollY || 0)); } catch (e) {}
    document.documentElement.style.opacity = "0.6";
    document.documentElement.style.transition = "opacity .25s ease";
    var pending = prefetchCache.get(url.href);
    prefetchCache.delete(url.href);
    (pending || fetchPage(url.href))
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newMain = doc.querySelector("#MainContent");
        var curMain = document.querySelector("#MainContent");
        if (!newMain || !curMain) throw new Error("no main");
        curMain.innerHTML = newMain.innerHTML;
        document.title = doc.title;
        document.body.className = doc.body.className;
        /* header stays intact (listeners live there) — refresh its cart badge */
        if (window.__bsCartBadges) window.__bsCartBadges();
        if (push) history.pushState({ bs: true }, "", url.href);
        lastPath = url.pathname + url.search;
        var targetY = 0;
        if (!push) {
          /* back/forward: return them to the exact spot they left */
          try { targetY = parseInt(sessionStorage.getItem("bs-scroll:" + lastPath), 10) || 0; } catch (e) { targetY = 0; }
        }
        window.scrollTo(0, targetY);
        reviveSwapped(curMain);
        /* iOS lays out async after innerHTML swaps — anchor again so
           arrivals never land mid-page */
        requestAnimationFrame(function () { window.scrollTo(0, targetY); });
        setTimeout(function () { if (!location.hash) window.scrollTo(0, targetY); }, 120);
        document.documentElement.style.opacity = "";
        navigating = false;
      })
      .catch(function () {
        /* graceful fallback: real navigation */
        window.location.href = url.href;
      });
  }

  var wipe = document.querySelector("[data-roomwipe]");
  var wipeLabel = document.querySelector("[data-roomwipe-label]");
  function wipeIn(kind) {
    if (!wipe) return 0;
    wipe.className = "roomwipe is-in roomwipe--" + kind;
    if (wipeLabel) wipeLabel.textContent = kind === "dark" ? "Entering the dark room\u2026" : "Stepping into the studio\u2026";
    return 460;
  }
  window.__bsWipeOut = function () {
    if (!wipe) return;
    setTimeout(function () { wipe.classList.remove("is-in"); }, 180);
  };

  function applyDept() {
    var m = location.search.match(/[?&]dept=([a-z0-9-]+)/);
    if (!m) return;
    var dept = m[1];
    var grid = document.querySelector("[data-archive-grid]");
    if (!grid) return;
    /* transform the room itself: art becomes the dark gallery */
    var room = document.querySelector(".archive");
    if (room) {
      room.classList.toggle("archive--dark", dept === "art");
      room.classList.toggle("archive--light", dept !== "art");
    }
    grid.querySelectorAll("[data-archive-type]").forEach(function (card) {
      var t = card.getAttribute("data-archive-type") || "";
      card.classList.toggle("is-filtered", t.indexOf(dept) === -1);
    });
    document.querySelectorAll("[data-filter-chip]").forEach(function (b) {
      b.classList.toggle("is-on", b.getAttribute("data-filter-chip") === dept);
    });
    var gw = document.querySelector(".gateway");
    if (gw) window.scrollTo({ top: gw.getBoundingClientRect().bottom + window.scrollY - 80, behavior: "auto" });
  }
  window.__bsApplyDept = applyDept;
  applyDept();

  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest("a[href]");
    var url = pjaxable(a);
    if (!url) return;
    e.preventDefault();
    var door = a.closest && a.closest("[data-room-door]");
    if (door) {
      /* crossing a threshold: the wipe leads, the room follows, music never stops */
      var delay = wipeIn(door.getAttribute("data-room-door"));
      setTimeout(function () { go(url, true); }, delay);
      return;
    }
    go(url, true);
  });

  var lastPath = location.pathname + location.search;
  window.addEventListener("popstate", function () {
    var nowPath = location.pathname + location.search;
    if (nowPath === lastPath) return; /* hash-only jump (e.g. press play) — native scroll, no refetch */
    lastPath = nowPath;
    try { go(new URL(location.href), false); } catch (err) { location.reload(); }
  });
})();

/* ==========================================================================
   V7 — VARIANT RESOLUTION, ARCHIVE FILTERS, LIVE CRATE, PJAX POLISH
   ========================================================================== */
(function () {
  "use strict";

  /* ---- Variant resolution: selected sizes/colors actually reach the cart ---- */
  function resolveVariant(form) {
    var jsonEl = form.querySelector("[data-variant-json]");
    var idInput = form.querySelector("[data-variant-id]");
    if (!jsonEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var chosen = [];
    var i = 1;
    while (true) {
      var checked = form.querySelector("input[name='option-" + i + "']:checked");
      if (!checked) break;
      chosen.push(checked.value);
      i++;
    }
    if (!chosen.length) return;
    var match = variants.find(function (v) {
      return chosen.every(function (val, idx) {
        /* Liquid's variants|json gives option1/option2/option3 (no options array) */
        var o = v["option" + (idx + 1)];
        if (o === undefined && v.options) o = v.options[idx];
        return o === val;
      });
    });
    if (!match) return;
    idInput.value = match.id;
    /* the selected color's photo becomes the photo they're viewing */
    if (match.featured_image && match.featured_image.src) {
      var mainImg = document.querySelector("[data-product-main-image]");
      if (mainImg && mainImg.src !== match.featured_image.src) {
        mainImg.src = match.featured_image.src;
      }
    }
    var submit = form.querySelector("[type='submit']");
    if (submit && !submit.disabled) {
      var money = (match.price / 100).toLocaleString(undefined, { style: "currency", currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD" });
      submit.textContent = match.available ? ("Add to Cart \u2014 " + money) : "Sold Out";
      submit.disabled = !match.available;
    }
  }
  document.addEventListener("change", function (e) {
    var form = e.target.closest && e.target.closest("[data-product-form]");
    if (form && /^option-\d+$/.test(e.target.name || "")) resolveVariant(form);
  });
  /* resolve once on load + after seamless navigation */
  function primeVariantForms(root) {
    (root || document).querySelectorAll("[data-product-form]").forEach(resolveVariant);
  }
  primeVariantForms(document);
  window.__bsPrimeVariants = primeVariantForms;

  /* ---- Archive department filters ---- */
  document.addEventListener("click", function (e) {
    var chip = e.target.closest && e.target.closest("[data-filter-chip]");
    if (!chip) return;
    var group = chip.closest(".archive-filters");
    var grid = document.querySelector("[data-archive-grid]");
    if (!group || !grid) return;
    group.querySelectorAll("[data-filter-chip]").forEach(function (b) { b.classList.toggle("is-on", b === chip); });
    var want = chip.getAttribute("data-filter-chip");
    grid.querySelectorAll("[data-archive-type]").forEach(function (card) {
      var show = want === "all" || card.getAttribute("data-archive-type") === want;
      card.classList.toggle("is-filtered", !show);
    });
  });

  /* ---- The Crate: live quantity + removal, no reloads ---- */
  function crateChange(row, qty) {
    var line = parseInt(row.getAttribute("data-crate-line"), 10);
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (qty === 0) {
          row.remove();
          /* line indexes shift after removal — renumber remaining rows */
          document.querySelectorAll("[data-crate-line]").forEach(function (r2, i) {
            r2.setAttribute("data-crate-line", i + 1);
          });
        } else {
          var item = cart.items[line - 1];
          if (item) {
            row.querySelector("[data-crate-qty]").textContent = item.quantity; /* reconcile with server truth */
            row.querySelector("[data-crate-line-price]").textContent = formatMoney(item.final_line_price);
          }
        }
        var sub = document.querySelector("[data-crate-subtotal]");
        var tot = document.querySelector("[data-crate-total]");
        if (sub) sub.textContent = formatMoney(cart.total_price);
        if (tot) tot.textContent = formatMoney(cart.total_price);
        if (window.__bsCartBadges) window.__bsCartBadges();
        if (cart.item_count === 0) window.location.reload();
      })
      .catch(function () {});
  }
  function formatMoney(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: cur });
  }
  /* Optimistic steppers: the count updates the instant you tap; rapid taps
     coalesce into one server request; the response reconciles prices. */
  var crateTimers = {};
  document.addEventListener("click", function (e) {
    var minus = e.target.closest && e.target.closest("[data-crate-minus]");
    var plus = e.target.closest && e.target.closest("[data-crate-plus]");
    var remove = e.target.closest && e.target.closest("[data-crate-remove]");
    if (!minus && !plus && !remove) return;
    var row = e.target.closest("[data-crate-line]");
    if (!row) return;
    var qtyEl = row.querySelector("[data-crate-qty]");
    var line = row.getAttribute("data-crate-line");

    if (remove) {
      row.style.opacity = "0.35";
      row.style.pointerEvents = "none";
      clearTimeout(crateTimers[line]);
      crateChange(row, 0);
      return;
    }

    var q = parseInt(qtyEl.textContent, 10) || 1;
    var target = Math.max(0, minus ? q - 1 : q + 1);
    qtyEl.textContent = target;                       /* instant */
    if (window.__bsCursor) window.__bsCursor("view", String(target));
    if (target === 0) { row.style.opacity = "0.35"; row.style.pointerEvents = "none"; }

    clearTimeout(crateTimers[line]);
    crateTimers[line] = setTimeout(function () {      /* one request per burst */
      crateChange(row, target);
    }, 240);
  });
})();


/* Deep link: /pages/art-gallery?piece=VARIANT scrolls to that exact piece
   and opens its lightbox — cart artwork clicks land on the piece itself. */
(function () {
  "use strict";
  var pieceRun = 0;
  function openPieceFromQuery() {
    var m = location.search.match(/[?&]piece=(\d+)/);
    if (!m) { pieceRun++; return; }
    var runId = ++pieceRun;
    var n = parseInt(m[1], 10);
    var tries = 0;
    (function attempt() {
      if (runId !== pieceRun) return;
      var frames = document.querySelectorAll("[data-lightbox-open]");
      var t = null;
      if (n >= 1 && n <= frames.length) {
        t = frames[n - 1];               /* gallery position: piece 1, 2, 3… */
      } else {
        t = document.querySelector('[data-lb-variant="' + m[1] + '"]'); /* legacy links */
      }
      if (t) {
        t.scrollIntoView({ block: "center", behavior: "auto" });
        t.click();
        if (t.blur) setTimeout(function () { t.blur(); }, 50);
        return;
      }
      if (++tries < 10) setTimeout(attempt, 300);
    })();
  }
  window.__bsOpenPiece = openPieceFromQuery;
  openPieceFromQuery();
})();

/* Product back button: real history when it exists, crossroads otherwise */
(function () {
  "use strict";
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-back]");
    if (!b) return;
    if (history.length > 1 && document.referrer.indexOf(location.origin) === 0) {
      history.back();
    } else if (history.length > 1) {
      history.back();
    } else {
      window.location.href = "/collections/all";
    }
  });
})();


/* Mobile-menu art strip: harvested from the gallery page itself, rendered as
   the same 3D canvases as the hallway, deep-linked by gallery position. */
(function () {
  "use strict";
  var filled = false;
  function build(items) {
    var track = document.querySelector("[data-mnav-art-track]");
    var strip = document.querySelector("[data-mnav-art]");
    if (!track || !strip || !items.length) return;
    var html = "";
    for (var copy = 0; copy < 2; copy++) {
      items.forEach(function (it, i) {
        /* DELIBERATE: this goes to the hallway with the piece opened, NOT to
           the product page. The 3D hallway is the whole point — artwork is
           presented in the dark room we built, not on a stock product page.
           Do not "fix" this to data-lb-url. It was changed once by mistake and
           reverted. */
        html += '<a class="mnav-canvas" href="/pages/art-gallery?piece=' + (i + 1) + '"' +
                ' data-product-canvas data-canvas-size="' + (it.s || "3x2") + '"' +
                ' data-src="' + it.img + '" aria-label="' + (it.t || "Artwork") + '"></a>';
      });
    }
    track.innerHTML = html;
    strip.hidden = false;
    filled = true;
    if (window.__bsProductCanvas) window.__bsProductCanvas(strip);
  }
  function harvest() {
    if (filled) return;
    try {
      var cached = sessionStorage.getItem("bs-mnav-art-v4");
      if (cached) { build(JSON.parse(cached)); if (filled) return; }
    } catch (e) {}
    fetch("/pages/art-gallery", { credentials: "same-origin", headers: { "X-Requested-With": "bs-pjax" } })
      .then(function (r) { if (!r.ok) throw new Error("no gallery"); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var items = [];
        doc.querySelectorAll("[data-lightbox-open]").forEach(function (el) {
          var img = el.getAttribute("data-lb-image");
          if (!img) return;
          items.push({
            img: img,
            s: el.getAttribute("data-canvas-size") || "3x2",
            t: (el.getAttribute("data-lb-title") || "").replace(/"/g, "")
          });
        });
        if (!items.length) return;
        try { sessionStorage.setItem("bs-mnav-art-v4", JSON.stringify(items)); } catch (e) {}
        build(items);
      })
      .catch(function () {});
  }
  window.__bsFillMenuArt = harvest;
})();


/* Gallery spotlight (touch devices): as you scroll the hallway, the piece
   nearest the viewport's heart gets the wall-light — one at a time, moving
   on with you. Desktop uses hover instead. */
(function () {
  "use strict";
  if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  var frames = [];
  var lit = null;
  var ticking = false;
  function collect() {
    frames = Array.prototype.slice.call(document.querySelectorAll(".hallway__frame"));
  }
  function pass() {
    ticking = false;
    if (!frames.length) return;
    var mid = window.innerHeight / 2;
    var band = window.innerHeight * 0.28;
    var best = null, bestDist = Infinity;
    for (var i = 0; i < frames.length; i++) {
      var r = frames[i].getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) continue;
      var dist = Math.abs((r.top + r.height / 2) - mid);
      if (dist < bestDist) { bestDist = dist; best = frames[i]; }
    }
    var next = (best && bestDist <= band) ? best : null;
    if (next !== lit) {
      if (lit) lit.classList.remove("is-lit");
      if (next) next.classList.add("is-lit");
      lit = next;
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(pass); }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  window.__bsSpotlight = function () { collect(); lit = null; onScroll(); };
  collect();
  onScroll();
})();
